import React, { Component } from "react";
import PropTypes from "prop-types";
import { Container, Row, Column } from "../grid";
import { StyleSheet, css } from "aphrodite";
import * as color from "../../constants/color";
import * as texchangePropTypes from "../../texchangePropTypes";
import * as util from "../../lib/util";
import FileBrowser from "../inputs/FileBrowser";
import TextInput from "../inputs/TextInput";
import SmallDropdown from "../inputs/SmallDropdown";
import ActionButton from "../ActionButton";
import { ReactComponent as DownloadIcon } from "../../images/SVGs/Download.svg";
import { ReactComponent as UploadIcon } from "../../images/SVGs/upload.svg";
import { ReactComponent as InputTypeIcon } from "../../images/SVGs/input-type.svg";
import { ReactComponent as CancelIcon } from "../../images/SVGs/close.svg";
import { ReactComponent as GarbageIcon } from "../../images/SVGs/garbage.svg";
import { ReactComponent as AlertIcon } from "../../images/alert-error.svg";
import Dropzone from "react-dropzone";
import format from "date-fns/format";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../Spinner";
import Modal from "../Modal";
import * as dataApi from "../../lib/api/data";
//import { currentPlan } from "../../constants/planTypes";
import Checkbox from "../inputs/Checkbox";
import SearchInput from "../inputs/SearchInput";
import * as searchInputTypes from "../../constants/searchInputTypes";
import { searchCensusCurrentPlans } from "../../lib/api/search";

const styles = StyleSheet.create({
    censusContainer: {},
    censusHeader: {
        backgroundColor: color.lightGray,
        height: 72,
    },
    censusHeaderU: {
        backgroundColor: color.lightGray3,
        height: 72,
    },
    confirmCensusHeader: {
        height: 72,
    },
    censusHeaderText: {
        fontSize: 16,
        color: color.darkestGray,
        lineHeight: "72px",
        display: "inline-block",
        marginLeft: 24,
    },
    confirmCensusHeaderText: {
        fontSize: 24,
        color: color.darkestGray,
        lineHeight: "72px",
        marginLeft: 24,
    },
    confirmCensusButtonHolder: {
        float: "right",
        marginTop: 12,
        marginRight: 24,
    },
    useExistingContainer: {
        float: "right",
        marginTop: 12,
        marginRight: 24,
    },
    censusOptionsText: {
        color: color.darkestGray,
        fontWeight: 300,
        marginTop: 32,
        fontSize: 20,
        marginLeft: 24,
    },
    censusOptionItem: {
        width: 310,
        marginLeft: "auto",
        marginRight: "auto",
    },
    censusOptionsContainer: {
        width: 1020,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 64,
        paddingBottom: 24,
    },
    censusOptionSeparatorTextContainer: {
        textAlign: "center",
        position: "relative",
        top: 100,
    },
    censusOptionItemHeader: {
        fontSize: 20,
    },
    downloadIcon: {
        float: "right",
        marginLeft: 8,
    },
    downloadTemplateIcon: {
        fontSize: 13,
        float: "right",
        lineHeight: "24px",
        marginTop: 2,
        cursor: "pointer",
        textDecoration: "none",
        color: color.darkestGray,
    },
    censusOptionItemHeaderText: {
        float: "left",
        lineHeight: "24px",
        marginBottom: 20,
    },
    censusButton: {
        clear: "both",
        borderRadius: 8,
    },
    loadCensusButton: {
        border: `1px dashed ${color.mediumYellow1}`,
        padding: "39px 24px",
        color: color.darkGray,
    },
    censusLoading: {
        marginTop: 50,
    },
    censusUploadErrors: {
        padding: 20,
        margin: 24,
        border: `1px solid ${color.red}`,
        backgroundColor: "#fff0f0",
        color: color.red,
    },
    censusUploadHeader: {
        fontSize: 20,
        marginBottom: 24,
        color: color.red,
        fontWeight: "bold",
    },
    censusSelectedButtonText: {
        color: color.darkRed,
        marginTop: 4,
        fontSize: 16,
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        display: "inline-block",
        maxWidth: 180,
    },
    censusFileSelected: {
        border: `1px dashed ${color.mediumRed}`,
    },
    createCensusButton: {
        backgroundColor: color.mediumYellow1,
        color: color.white,
        padding: "52px 24px",
        cursor: "pointer",
    },
    createCensusButton2: {
        backgroundColor: color.darkRed,
        color: color.white,
        padding: "52px 24px",
        cursor: "pointer",
    },
    censusIcon: {
        float: "left",
        marginRight: 16,
    },
    uploadIcon: {
        fill: color.mediumYellow1,
    },
    censusUploadedIcon: {
        fill: color.darkRed,
    },
    inputTypeIcon: {
        position: "relative",
        top: -8,
        width: 40,
        height: 40,
    },
    censusButtonText: {
        fontSize: 20,
    },
    censusButtonContainer: {
        clear: "both",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 86,
        marginBottom: 30,
        textAlign: "center",
    },
    currentPlansButton: {
        width: 200,
        marginLeft: 18,
    },
    cancelButton: {
        width: 200,
        marginLeft: 18,
    },
    submitCensusButton: {
        width: 200,
        marginLeft: 18,
    },
    clearCensusButton: {
        display: "inline-block",
        float: "right",
        cursor: "pointer",
    },
    currentPlanCellWrap: {
        display: "flex",
        alignItems: "center",
        gap: 6,
    },
    hover: {
        position: "relative",
        color: color.mediumYellow1,
        flexShrink: 0,
    },
    __hover: {
        position: "absolute",
        top: -10,
        right: -5,
        padding: 8,
        width: "100%",
        height: 30,
        color: color.tableText,
        backgroundColor: color.white,
        border: `1px solid ${color.tableBorder}`,
        overflow: "hidden",
        opacity: 0,
        zIndex: 20000,
        ":hover": {
            opacity: 1,
            top: -20,
            minWidth: 340,
            minHeight: 63,
            overflow: "auto",
        },
    },
    __nohover: {
        opacity: 1,
        cursor: "default",
        border: `1px solid ${color.mediumYellow1}`,
        borderRadius: "50%",
        width: 16,
        height: 16,
        lineHeight: "14px",
        textAlign: "center",
        fontSize: 11,
        fontWeight: 700,
        backgroundColor: color.white,
        ":hover": {
            opacity: 0,
        },
    },
    manualCensusContainer: {
        marginLeft: 2,
        paddingBottom: 24,
    },
    censusTable: {
        width: "100%",
        marginTop: 10,
        marginBottom: 20,
        borderCollapse: "collapse",
    },
    censusTableHeader: {
        fontSize: 13,
        color: color.mediumYellow1,
        padding: 10,
        fontWeight: 500,
        textAlign: "left",
        whiteSpace: "nowrap",
        borderBottom: `1px solid ${color.mediumGray}`,
    },
    censusTableCell: {
        fontSize: 14,
        color: color.tableText,
        padding: "3px 2px",
        borderBottom: `1px solid ${color.tableBorder}`,
        lineHeight: "16px",
        //having it combined affected modal in weird ways, so separated it out:
        ":nth-child(1)": { fontWeight: 500 },
        ":nth-child(2)": { fontWeight: 500 },
    },
    censusDobCell: {
        width: "109px",
        minWidth: "109px",
        maxWidth: "109px",
    },
    censusZipCell: {
        width: "74px",
        minWidth: "74px",
        maxWidth: "74px",
    },
    censusTitleCell: {
        width: "74px",
        minWidth: "74px",
        maxWidth: "74px",
    },
    censusSalaryCell: {
        width: "84px",
        minWidth: "84px",
        maxWidth: "84px",
    },
    censusPlanFlagCell: {
        width: "58px",
        minWidth: "58px",
        maxWidth: "58px",
    },
    censusActionCell: {
        width: "26px",
        minWidth: "26px",
        maxWidth: "26px",
    },
    checkLabel: {
        display: "inline-block",
        position: "relative",
        border: "none",
        marginTop: 8,
        marginBottom: 10,
        fontSize: 14,
        color: color.darkGray,
        "-webkit-appearance": "none",
        cursor: "pointer",
        ":first-child": {
            marginRight: 0,
        },
        width: "100%",
        textAlign: "center",
    },
    censusTableCellLink: {
        fontSize: 16,
        color: color.mediumYellow1,
        textDecoration: "underline",
        cursor: "pointer",
    },
    censusTableCellCenter: {
        textAlign: "center",
    },
    censusTableCellRight: {
        textAlign: "right",
    },
    dependentStatusContainer: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginLeft: 10,
    },
    dependentStatusLabel: {
        fontSize: 14,
        color: color.tableText,
        lineHeight: "16px",
        fontWeight: 500,
        whiteSpace: "nowrap",
    },
    greenBar: {
        borderLeft: `4px solid ${color.mediumRed}`,
    },
    blueBar: {
        borderLeft: `4px solid ${color.borderBackgroundGray}`,
    },
    redBar: {
        borderLeft: `4px solid ${color.red}`,
    },
    modalContent: {
        width: 400,
    },
    modalInstructions: {
        color: color.darkestGray,
        fontSize: 14,
        marginBottom: 8,
        textAlign: "left",
        lineHeight: "18px",
    },
    modalButtonContainer: {
        marginTop: 24,
        display: "flex",
        justifyContent: "space-around",
    },
    modalButton: {
        width: 150,
    },
    modal_Content: {
        width: 1000,
        padding: 24,
    },
    modal_FormSection: {
        marginBottom: 18,
    },
    modal_MappingBox: {
        border: `1px solid ${color.mediumGray2}`,
        borderRadius: 4,
        overflow: "visible",
        backgroundColor: color.white,
    },
    modal_Box: {
        border: `1px solid ${color.mediumGray2}`,
        borderRadius: 4,
        overflow: "hidden",
        backgroundColor: color.white,
    },
    modal_GridHeader: {
        display: "grid",
        gridTemplateColumns: "40px 72px 1fr 44px 1fr 34px",
        columnGap: 10,
        padding: "10px 14px",
        backgroundColor: color.lightGray3,
        borderBottom: `1px solid ${color.mediumGray2}`,
        color: color.mediumGray,
        fontSize: 12,
        fontWeight: 600,
    },
    modal_GridRow: {
        display: "grid",
        gridTemplateColumns: "40px 72px 1fr 44px 1fr 34px",
        columnGap: 10,
        alignItems: "center",
        padding: "8px 14px",
        borderBottom: `1px solid ${color.mediumGray2}`,
    },
    modal_LastRow: {
        borderBottom: "none",
    },
    modal_RowNum: {
        color: color.mediumGray,
        fontSize: 13,
    },
    modal_BasePlanCell: {
        display: "flex",
        alignItems: "center",
        gap: 6,
    },
    modalCCP_Input: {
        width: "100%",
        height: 30,
        border: `1px solid ${color.mediumGray2}`,
        borderRadius: 4,
        padding: "0 10px",
        color: color.darkestGray,
        backgroundColor: color.white,
        fontSize: 13,
        boxSizing: "border-box",
    },
    modal_Select: {
        width: "100%",
        height: 30,
        border: `1px solid ${color.mediumGray2}`,
        borderRadius: 4,
        padding: "0 10px",
        color: color.mediumGray,
        backgroundColor: color.white,
        fontSize: 13,
        boxSizing: "border-box",
    },
    modal_SearchInput: {
        marginTop: 0,
        marginBottom: 0,
    },
    modal_Arrow: {
        textAlign: "center",
        color: color.mediumGray,
        fontSize: 14,
    },
    modal_Trash: {
        textAlign: "center",
        color: color.mediumGray,
        fontSize: 14,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modal_TrashIcon: {
        width: 14,
        height: 14,
    },
    modal_AddRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 10,
        color: color.mediumGray,
        fontSize: 12,
    },
    modal_MappingLegend: {
        display: "flex",
        gap: 16,
    },
    modal_LegendItem: {
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
    },
    modal_OrangeDot: {
        display: "inline-block",
        marginLeft: 8,
        width: 8,
        height: 8,
        borderRadius: "50%",
        backgroundColor: color.mediumOrange,
    },
    modal_GreenDot: {
        display: "inline-block",
        marginLeft: 8,
        width: 8,
        height: 8,
        borderRadius: "50%",
        backgroundColor: color.mediumGreen,
    },
    modal_MappedDot: {
        width: 8,
        height: 8,
        borderRadius: "50%",
        backgroundColor: color.mediumGreen,
    },
    modal_UnmappedDot: {
        width: 8,
        height: 8,
        borderRadius: "50%",
        backgroundColor: color.mediumOrange,
    },
    modal_AddPlanButton: {
        border: `1px solid ${color.mediumRed}`,
        color: color.mediumRed,
        borderRadius: 4,
        backgroundColor: color.white,
        fontSize: 14,
        lineHeight: "28px",
        height: 30,
        padding: "0 12px",
        fontWeight: 500,
        cursor: "pointer",
    },
    modal_SectionTitle: {
        color: color.darkestGray,
        fontSize: 16,
        fontWeight: 500,
        marginBottom: 10,
    },
    modal_ToggleRow: {
        display: "flex",
        gap: 10,
    },
    modal_ToggleButton: {
        border: `1px solid ${color.mediumGray2}`,
        borderRadius: 4,
        backgroundColor: color.white,
        color: color.darkestGray,
        fontSize: 14,
        height: 32,
        minWidth: 74,
        padding: "0 14px",
        cursor: "pointer",
    },
    modal_ToggleButtonActive: {
        backgroundColor: color.mediumRed,
        border: `1px solid ${color.mediumRed}`,
        color: color.white,
    },
    modal_ToggleButtonDisabled: {
        opacity: 0.5,
        cursor: "not-allowed",
    },
    modal_HeaderSection: {
        border: `1px solid ${color.mediumGray2}`,
        borderRadius: 10,
        backgroundColor: color.lightGray,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: 20,
        padding: "18px 18px 16px 18px",
        gap: 24,
        flexWrap: "wrap",
    },
    modal_HeaderLeftGroup: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 8,
        minWidth: 380,
        flex: 1,
    },
    modal_HeaderLabel: {
        fontSize: 14,
        fontWeight: 500,
        color: color.darkestGray,
        marginRight: 0,
    },
    modal_HeaderLabelRequired: {
        color: color.mediumRed,
        marginLeft: 4,
    },
    modal_HeaderControlRow: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        flexWrap: "wrap",
    },
    modal_FundingSwitchConfirm: {
        marginTop: 2,
        border: `2px solid ${color.mediumOrange}`,
        borderRadius: 10,
        backgroundColor: color.white,
        padding: 16,
        width: "100%",
        maxWidth: 420,
        boxSizing: "border-box",
        boxShadow: "0 8px 20px rgba(0, 0, 0, 0.12)",
    },
    modal_FundingSwitchHeader: {
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
    },
    modal_FundingSwitchIcon: {
        width: 18,
        height: 18,
        minWidth: 18,
        marginTop: 2,
    },
    modal_FundingSwitchTitle: {
        fontSize: 14,
        fontWeight: 500,
        color: color.darkestGray,
        lineHeight: "20px",
    },
    modal_FundingSwitchText: {
        marginTop: 6,
        fontSize: 13,
        color: color.darkGray,
        lineHeight: "18px",
    },
    modal_FundingSwitchSubText: {
        marginTop: 4,
        fontSize: 12,
        color: color.mediumGray,
        fontStyle: "italic",
        lineHeight: "16px",
    },
    modal_FundingSwitchDivider: {
        marginTop: 14,
        marginBottom: 12,
        height: 1,
        backgroundColor: color.mediumGray2,
    },
    modal_FundingSwitchActions: {
        display: "flex",
        justifyContent: "flex-end",
        gap: 10,
    },
    modal_FundingSwitchCancel: {
        minWidth: 100,
    },
    modal_FundingSwitchConfirmButton: {
        minWidth: 160,
        whiteSpace: "nowrap",
    },
    modal_PlanTypeButton: {
        minWidth: 114,
        whiteSpace: "nowrap",
    },
    modal_HeaderRightGroup: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 8,
        minWidth: 320,
        flex: 1,
    },
    modal_CarrierDropdown: {
        width: "100%",
        maxWidth: 380,
        height: 32,
        border: `1px solid ${color.mediumGray2}`,
        borderRadius: 4,
        padding: "0 10px",
        color: color.darkestGray,
        backgroundColor: color.white,
        fontSize: 13,
        boxSizing: "border-box",
        cursor: "pointer",
    },
    modal_CarrierDropdownSmall: {
        width: "100%",
        maxWidth: 380,
    },
    modal_CarrierDropdownWrap: {
        width: "100%",
        maxWidth: 380,
    },
    modal_CarrierDropdownDisabled: {
        pointerEvents: "none",
        opacity: 0.6,
    },
    modal_DisabledOverlay: {
        opacity: 0.5,
        pointerEvents: "none",
    },
    modal_HeaderHelperText: {
        fontSize: 12,
        color: color.mediumGray,
        fontStyle: "italic",
        lineHeight: "16px",
    },
    modal_AgeWarning: {
        marginTop: 14,
        border: `1px solid ${color.lightYellow1}`,
        backgroundColor: color.lightYellow,
        color: color.mediumYellow1,
        padding: "16px 14px",
        fontSize: 14,
        lineHeight: "22px",
    },
    modal_RateHeader: {
        display: "grid",
        gridTemplateColumns: "1fr 96px 96px 96px 96px",
        columnGap: 8,
        padding: "10px 12px",
        backgroundColor: color.lightGray3,
        borderBottom: `1px solid ${color.mediumGray2}`,
        color: color.mediumGray,
        fontSize: 12,
        fontWeight: 600,
    },
    modal_RateRow: {
        display: "grid",
        gridTemplateColumns: "1fr 96px 96px 96px 96px",
        columnGap: 8,
        padding: "8px 12px",
        alignItems: "center",
        borderBottom: `1px solid ${color.mediumGray2}`,
    },
    modal_RateName: {
        color: color.darkestGray,
        fontSize: 13,
        fontStyle: "normal",
    },
    modal_Currency: {
        display: "flex",
        border: `1px solid ${color.mediumGray2}`,
        borderRadius: 4,
        overflow: "hidden",
        height: 30,
        backgroundColor: color.white,
    },
    modal_CurrencySign: {
        width: 24,
        backgroundColor: color.lightGray3,
        borderRight: `1px solid ${color.mediumGray2}`,
        color: color.darkestGray,
        textAlign: "center",
        lineHeight: "30px",
        fontSize: 13,
    },
    modal_CurrencyValue: {
        flex: 1,
        textAlign: "right",
        color: color.darkestGray,
        paddingRight: 8,
        fontSize: 13,
        border: "none",
        outline: "none",
        backgroundColor: "transparent",
        width: "100%",
        height: "100%",
    },
    modal_ButtonContainer: {
        marginTop: 24,
        display: "flex",
        justifyContent: "flex-end",
        gap: 14,
    },
    modal_Button: {
        width: 150,
    },
    planHeaderLabel: {
        marginBottom: "4px",
        textAlign: "center",
    },
    planFlagHeader: {
        paddingLeft: 0,
        paddingRight: 0,
    },
    planHeaderLinks: {
        fontSize: "12px",
        textAlign: "center",
    },
    planHeaderLink: {
        color: color.mediumYellow1,
        cursor: "pointer",
        textDecoration: "underline",
    },
    censusHeaderCol2pct: {
        width: "2%",
    },
    censusHeaderCol8pctWith100px: {
        width: "8%",
        maxWidth: "100px",
    },
    censusHeaderColDOB: {
        width: "109px",
        minWidth: "109px",
        maxWidth: "109px",
    },
    censusHeaderCol3pct: {
        width: "3%",
    },
    censusHeaderColZip: {
        width: "74px",
        minWidth: "74px",
        maxWidth: "74px",
    },
    censusHeaderColTitle: {
        width: "74px",
        minWidth: "74px",
        maxWidth: "74px",
    },
    censusHeaderColSalary: {
        width: "84px",
        minWidth: "84px",
        maxWidth: "84px",
    },
    censusHeaderColEmail: {
        width: "8%",
        maxWidth: "120px",
    },
    censusHeaderColPlan: {
        minWidth: "120px",
    },
    modal_ButtonPrimary: {
        width: 150,
        color: color.white,
    },
});

const strings = {
    useExistingCensusButton: "Use This Census",
    censusOptionsLabel: "Or do one of the following options:",
    addCensusManually: "Add Census Manually",
    loadCensus: "Load Census",
    createCensus: "Create Census",
    censusDetails: "Census Details",
    downloadTemplate: "Download Template",
    confirmCensusButton: "Confirm Census",
    currentPlansModalButton: "Current Plans",
    censusUploadErrors: "Please fix these errors",
    cancelButton: "Cancel",
    backButton: "Back",
    submitButton: "Submit",
    currentPlansButton: "Current Plans",
    isPPO: "PPO",
    isHMO: "HMO",
    onCobra: "COBRA",
    isTobacco: "TOB",
};

const inputNames = {
    relationship: "relationship",
    firstName: "firstName",
    lastName: "lastName",
    dob: "dob",
    gender: "gender",
    currentMedicalPlanName: "currentMedicalPlanName",
    medicalCoverage: "medicalCoverage",
    dentalCoverage: "dentalCoverage",
    visionCoverage: "visionCoverage",
    lifeCoverage: "lifeCoverage",
    homePostalCode: "homePostalCode",
    workPostalCode: "workPostalCode",
    occupation: "occupation",
    salary: "salary",
    isPPO: "isPPO",
    isHMO: "isHMO",
    onCobra: "onCobra",
    isTobacco: "isTobacco",
    childDependentStatus: "childDependentStatus",
};

const DEFAULT_COMPOSITE_RATES = {
    EE: "0.00",
    ES: "0.00",
    EC: "0.00",
    EF: "0.00",
};

const ENABLE_DEPENDENT_ZIP_EDIT = false;

export default class QuoteCensus extends Component {
    static propTypes = {
        quote: texchangePropTypes.quote,
        areaId: PropTypes.number,
        uploadCensus: PropTypes.func.isRequired,
        copyCensus: PropTypes.func.isRequired,
        copyCensusU: PropTypes.func.isRequired,
        isSaving: PropTypes.bool.isRequired,
    };

    _currentPlanAliasOnFocusByRow = {};
    _currentPlanAliasRevertedOnBlur = false;

    state = {
        censusUpload: null,
        isSubmittingCensus: false,
        isManualCensus: false,
        inputs: {
            [inputNames.relationship]: "",
            [inputNames.firstName]: "",
            [inputNames.lastName]: "",
            [inputNames.dob]: "",
            [inputNames.gender]: "",
            [inputNames.medicalCoverage]: "",
            [inputNames.dentalCoverage]: "",
            [inputNames.visionCoverage]: "",
            [inputNames.lifeCoverage]: "",
            [inputNames.homePostalCode]: "",
            [inputNames.workPostalCode]: "",
            [inputNames.occupation]: "",
            [inputNames.salary]: "",
        },
        currentPlansModalSnapshot: null,
        currentPlanSelectionByRow: {},
        mappedPlansByRow: {
            // "1": {
            //   rowNum: 1,
            //   alias: "Gold 500",
            //   mappedPlanId: 12345,
            //   mappedPlanName: "Aetna ABC 5000 PPO (2026)",
            //   rates: { EE: "0.00", ES: "0.00", EC: "0.00", EF: "0.00" }
            // }
        },

        // NEW: subset for non-modal dropdown (mapped only)
        mappedPlanOptions: [
            // { label: "Aetna ABC 5000 PPO (2026)", value: 12345, alias: "Gold 500" }
        ],
        relationship: [{ name: "SP" }, { name: "C" }],
        gender: [
            { id: "M", name: "M" },
            { id: "F", name: "F" },
        ],
        currentMedicalPlanName: [
            { id: "1", name: "Test Plan 1" },
            { id: "2", name: "Test Plan 2" },
            { id: "3", name: "Test Plan 3" },
            { id: "4", name: "Test Plan 4" },
        ],
        coverage: [
            { id: "1", name: "EE" },
            { id: "2", name: "ES" },
            { id: "3", name: "EC" },
            { id: "4", name: "EF" },
            { id: "5", name: "W" },
        ],
        coverage2: [
            { id: "1", name: "EE" },
            { id: "5", name: "W" },
        ],
        yesNo: [
            { id: "1", name: "Yes" },
            { id: "0", name: "No" },
        ],
        errors: [],
        census: [],
        currentPlans: [],
        needsISLAndPEPM: false,
        stopLossAmounts: [],
        stopLossAmount: 0,
        defaultPEPM: 0,
        networks: [],
        defaultNetwork: "",
        showErisa: false,
        erisa: true,
        showModal: false,
        showCurrentPlansModal: false,
        isCopy: false,
        isCopyU: false,
        currentCensus: 1,
        currentPlansRateType: "composite",
        currentPlansBasePlanRow: null,
        // Start - Funding Type and Carrier Filtering
        // currentPlansFundingType: null = no filter, "0" = Fully Insured, "1" = Level Funded
        currentPlansFundingType: null,
        // currentPlansCarrier: defaults to "All Carriers"
        currentPlansCarrier: "All Carriers",
        // List of available carriers extracted from the plan cache
        currentPlansAvailableCarriers: [],
        // Pending funding type switch that requires confirmation
        pendingCurrentPlansFundingType: null,
        // Persisted funding type and carrier (survive across modal open/close/save cycles)
        savedCurrentPlansFundingType: null,
        savedCurrentPlansCarrier: "All Carriers",
        // End - Funding Type and Carrier Filtering
    };

    componentDidMount() {
        const { quote } = this.props;
        dataApi.checkISLAndPEPM(quote.id).then(response => {
            if (response && response.needsISLAndPEPM) {
                this.setState({
                    needsISLAndPEPM: true,
                    stopLossAmounts: response.stopLossAmounts,
                    stopLossAmount:
                        response.stopLossAmounts && response.stopLossAmounts.length > 0
                            ? response.stopLossAmounts[0]
                            : 0,
                    defaultPEPM: response.defaultPEPM,
                    networks: response.networks,
                    defaultNetwork:
                        response.networks && response.networks.length > 0
                            ? response.networks[0]
                            : "",
                    showErisa: response.needsERISA,
                });
            }
        });
    }

    componentDidUpdate(nextProps, nextState) {
        if (nextProps.quote.census !== nextState.census && nextProps.quote.census.length > 0) {
            const normalizedCensus = this._normalizeCensusRows(nextProps.quote.census);

            const applyHydratedState = currentPlansCache => {
                const hydratedCurrentPlans = this._buildCurrentPlansStateFromQuote(
                    nextProps.quote,
                    normalizedCensus,
                    currentPlansCache,
                );
                this.setState({
                    census: normalizedCensus,
                    currentCensus: normalizedCensus.length + 1,
                    isManualCensus: true,
                    isSubmittingCensus: false,
                    loading: false,
                    ...hydratedCurrentPlans,
                });
            };

            if (
                Array.isArray(nextProps.quote.mappedPlans) &&
                nextProps.quote.mappedPlans.length > 0
            ) {
                this._loadCurrentPlansCache()
                    .then(cache => {
                        applyHydratedState(cache);
                    })
                    .catch(() => {
                        applyHydratedState(this.state.currentPlansCache || []);
                    });
            } else {
                applyHydratedState(this.state.currentPlansCache || []);
            }

            nextProps.quote.census = [];
        } else if (
            nextProps.quote.census !== nextState.census &&
            nextProps.quote.census.length === 0 &&
            nextProps.quote.censusUploadErrors &&
            nextState.isSubmittingCensus === true
        ) {
            //full reset of the upload file...  invalid file...
            this.setState({
                isSubmittingCensus: false,
                loading: false,
            });
        }
    }

    _normalizeCensusRows = censusRows =>
        (censusRows || []).map(row => ({
            ...row,
            isPPO: row.isPPO !== null && row.isPPO !== undefined ? row.isPPO : true,
            isHMO: row.isHMO !== null && row.isHMO !== undefined ? row.isHMO : true,
            isTobacco: row.isTobacco !== null ? row.isTobacco : false,
            onCobra: row.onCobra !== null ? row.onCobra : false,
            dependents: (row.dependents || []).map(dep => ({
                ...dep,
                homePostalCode: !ENABLE_DEPENDENT_ZIP_EDIT
                    ? row.homePostalCode || dep.homePostalCode || ""
                    : dep.homePostalCode,
                childDependentStatus:
                    dep.dependentType !== "Spouse"
                        ? dep.childDependentStatus || "Child"
                        : dep.childDependentStatus || null,
            })),
        }));

    _getNormalizedCurrentPlansRateType = rateType => {
        const normalized = (rateType || "").toString().toLowerCase();
        return normalized === "age" || normalized === "composite"
            ? normalized
            : this.state.currentPlansRateType || "composite";
    };

    _isLevelFundedSelected = fundingType => String(fundingType) === "1";

    _normalizeCurrentPlanAlias = alias =>
        (alias === null || alias === undefined ? "" : String(alias)).trim().toLowerCase();

    _getCurrentPlanAliasValue = (plan, index) => {
        if (typeof plan === "string") {
            return plan;
        }

        if (plan && plan.alias !== undefined && plan.alias !== null) {
            return plan.alias;
        }

        if (plan && plan.name !== undefined && plan.name !== null) {
            return plan.name;
        }

        return `Plan ${index + 1}`;
    };

    _getDuplicateCurrentPlanAliases = (plans = this.state.currentPlans || []) => {
        const firstAliasByKey = {};
        const duplicateAliases = [];

        plans.forEach((plan, index) => {
            const alias = this._getCurrentPlanAliasValue(plan, index);
            const normalizedAlias = this._normalizeCurrentPlanAlias(alias);

            if (!normalizedAlias) {
                return;
            }

            if (firstAliasByKey[normalizedAlias] === undefined) {
                firstAliasByKey[normalizedAlias] = String(alias).trim();
                return;
            }

            if (duplicateAliases.indexOf(firstAliasByKey[normalizedAlias]) === -1) {
                duplicateAliases.push(firstAliasByKey[normalizedAlias]);
            }
        });

        return duplicateAliases;
    };

    _getCurrentPlanAliasInputValue = (rowNum, plans = this.state.currentPlans || []) => {
        const rowIndex = Number(rowNum) - 1;
        const plan = plans[rowIndex];

        if (typeof plan === "string") {
            return plan;
        }

        return (plan && (plan.alias || plan.name)) || "";
    };

    _isCurrentPlanAliasDuplicateForRow = (rowNum, plans = this.state.currentPlans || []) => {
        const currentAlias = this._getCurrentPlanAliasInputValue(rowNum, plans);
        const normalizedCurrentAlias = this._normalizeCurrentPlanAlias(currentAlias);

        if (!normalizedCurrentAlias) {
            return false;
        }

        return plans.some((plan, index) => {
            const otherRowNum = index + 1;
            if (Number(otherRowNum) === Number(rowNum)) {
                return false;
            }

            const otherAlias = this._getCurrentPlanAliasInputValue(otherRowNum, plans);
            return this._normalizeCurrentPlanAlias(otherAlias) === normalizedCurrentAlias;
        });
    };

    _handleCurrentPlanAliasFocus = rowNum => {
        this._currentPlanAliasOnFocusByRow[rowNum] = this._getCurrentPlanAliasInputValue(rowNum);
    };

    _handleCurrentPlanAliasBlur = rowNum => {
        const fallbackAlias = this._currentPlanAliasOnFocusByRow[rowNum];
        const shouldRevert = this._isCurrentPlanAliasDuplicateForRow(rowNum);

        delete this._currentPlanAliasOnFocusByRow[rowNum];

        if (!shouldRevert) {
            return;
        }

        this._currentPlanAliasRevertedOnBlur = true;
        this._handleCurrentPlanAliasChange(rowNum, fallbackAlias || "");
        toast.error("Plan Alias values must be unique. Reverted to previous value.", {
            toastId: "current-plans-duplicate-alias-blur",
        });
    };

    _toCompositeRateString = value => {
        if (value === null || value === undefined || value === "") {
            return "0.00";
        }
        return this._formatCompositeRate(String(value));
    };

    _buildCurrentPlansStateFromQuote = (quote, normalizedCensus, currentPlansCache = []) => {
        const quoteCurrentPlans = Array.isArray(quote.currentPlans) ? quote.currentPlans : [];
        const quoteMappedPlans = Array.isArray(quote.mappedPlans) ? quote.mappedPlans : [];

        const getMappedAlias = mapped =>
            (mapped &&
                (mapped.alias ||
                    mapped.currentMedicalPlanName ||
                    mapped.currentPlanAlias ||
                    mapped.planAlias)) ||
            "";
        const getMappedPlanId = mapped => {
            if (!mapped) {
                return "";
            }
            if (mapped.mappedPlanId !== null && mapped.mappedPlanId !== undefined) {
                return String(mapped.mappedPlanId);
            }
            if (mapped.currentMedicalPlanId !== null && mapped.currentMedicalPlanId !== undefined) {
                return String(mapped.currentMedicalPlanId);
            }
            return "";
        };
        const getMappedRate = (mapped, tierKey) => {
            if (!mapped) {
                return null;
            }

            const directRateKey = tierKey.toLowerCase();
            const compositeRateKey = `currentMedicalComposite${tierKey}Rate`;

            if (mapped[directRateKey] !== undefined && mapped[directRateKey] !== null) {
                return mapped[directRateKey];
            }
            if (mapped[compositeRateKey] !== undefined && mapped[compositeRateKey] !== null) {
                return mapped[compositeRateKey];
            }
            return null;
        };

        const currentPlansFromApi = quoteCurrentPlans.map((plan, index) => {
            if (typeof plan === "string") {
                return {
                    id: index + 1,
                    alias: plan,
                    selectedPlan: "",
                    isBasePlan: false,
                };
            }
            return {
                id: index + 1,
                alias: (plan && (plan.alias || plan.name)) || `Plan ${index + 1}`,
                selectedPlan: "",
                isBasePlan: false,
            };
        });

        if (quoteMappedPlans.length === 0) {
            return {
                currentPlans: currentPlansFromApi,
                mappedPlansByRow: {},
                currentPlanSelectionByRow: {},
                mappedPlanOptions: [],
                currentPlansBasePlanRow: null,
                currentPlansRateType: this._getNormalizedCurrentPlansRateType(
                    quote.currentPlansRateType,
                ),
                currentPlansFundingType: null,
                savedCurrentPlansFundingType: null,
                currentPlansCarrier: "All Carriers",
                savedCurrentPlansCarrier: "All Carriers",
            };
        }

        const plansById = new Map(
            (currentPlansCache || [])
                .filter(plan => plan && plan.value !== null && plan.value !== undefined)
                .map(plan => [String(plan.value), plan]),
        );

        const aliasKey = alias =>
            (alias === null || alias === undefined ? "" : String(alias)).trim().toLowerCase();

        const currentPlans = (currentPlansFromApi.length > 0
            ? currentPlansFromApi
            : quoteMappedPlans.map((mapped, index) => ({
                  id: index + 1,
                  alias: (mapped && mapped.alias) || `Plan ${index + 1}`,
                  selectedPlan: "",
                  isBasePlan: false,
              }))
        ).map((plan, index) => ({
            id: index + 1,
            alias:
                (plan &&
                    (typeof plan === "string" ? plan : plan.alias || plan.name || plan.label)) ||
                `Plan ${index + 1}`,
            selectedPlan: "",
            isBasePlan: false,
        }));

        const mappedPlansByRow = {};
        const currentPlanSelectionByRow = {};
        const mappedPlanOptions = [];
        const baseRows = [];
        const fundingTypes = new Set();

        const remainingMappedPlans = [...quoteMappedPlans];

        currentPlans.forEach((plan, index) => {
            const rowNum = index + 1;
            const alias = (plan && plan.alias) || `Plan ${rowNum}`;
            const mappedIndex = remainingMappedPlans.findIndex(
                mapped => aliasKey(getMappedAlias(mapped)) === aliasKey(alias),
            );

            if (mappedIndex === -1) {
                return;
            }

            const mapped = remainingMappedPlans[mappedIndex];
            remainingMappedPlans.splice(mappedIndex, 1);
            const mappedPlanId = getMappedPlanId(mapped);
            const matchedPlan = mappedPlanId ? plansById.get(mappedPlanId) : null;

            currentPlans[index] = {
                ...currentPlans[index],
                selectedPlan: matchedPlan ? mappedPlanId : "",
            };

            if (!matchedPlan) {
                currentPlanSelectionByRow[rowNum] = { value: "", label: "" };
                return;
            }

            const mappedPlanName = matchedPlan.label || alias;
            const rates = {
                EE: this._toCompositeRateString(getMappedRate(mapped, "EE")),
                ES: this._toCompositeRateString(getMappedRate(mapped, "ES")),
                EC: this._toCompositeRateString(getMappedRate(mapped, "EC")),
                EF: this._toCompositeRateString(getMappedRate(mapped, "EF")),
            };

            mappedPlansByRow[rowNum] = {
                rowNum,
                alias,
                mappedPlanId,
                mappedPlanName,
                rates,
            };
            currentPlanSelectionByRow[rowNum] = {
                value: mappedPlanId,
                label: mappedPlanName,
            };
            mappedPlanOptions.push({
                label: mappedPlanName,
                value: mappedPlanId,
                alias,
            });

            if (mapped && mapped.isBase) {
                baseRows.push(rowNum);
            }

            if (matchedPlan.levelFunded !== null && matchedPlan.levelFunded !== undefined) {
                fundingTypes.add(String(matchedPlan.levelFunded));
            }
        });

        // Include mapped rows not found in currentPlans aliases (defensive fallback).
        remainingMappedPlans.forEach(mapped => {
            const rowNum = currentPlans.length + 1;
            const alias = getMappedAlias(mapped) || `Plan ${rowNum}`;
            const mappedPlanId = getMappedPlanId(mapped);
            const matchedPlan = mappedPlanId ? plansById.get(mappedPlanId) : null;

            currentPlans.push({
                id: rowNum,
                alias,
                selectedPlan: matchedPlan ? mappedPlanId : "",
                isBasePlan: false,
            });

            if (!matchedPlan) {
                currentPlanSelectionByRow[rowNum] = { value: "", label: "" };
                return;
            }

            const mappedPlanName = matchedPlan.label || alias;
            const rates = {
                EE: this._toCompositeRateString(getMappedRate(mapped, "EE")),
                ES: this._toCompositeRateString(getMappedRate(mapped, "ES")),
                EC: this._toCompositeRateString(getMappedRate(mapped, "EC")),
                EF: this._toCompositeRateString(getMappedRate(mapped, "EF")),
            };

            mappedPlansByRow[rowNum] = {
                rowNum,
                alias,
                mappedPlanId,
                mappedPlanName,
                rates,
            };
            currentPlanSelectionByRow[rowNum] = {
                value: mappedPlanId,
                label: mappedPlanName,
            };
            mappedPlanOptions.push({
                label: mappedPlanName,
                value: mappedPlanId,
                alias,
            });

            if (mapped && mapped.isBase) {
                baseRows.push(rowNum);
            }

            if (matchedPlan.levelFunded !== null && matchedPlan.levelFunded !== undefined) {
                fundingTypes.add(String(matchedPlan.levelFunded));
            }
        });

        if (currentPlans.length === 0) {
            const fallbackPlanNames = new Set();
            normalizedCensus.forEach(member => {
                if (member.currentMedicalPlanName) {
                    fallbackPlanNames.add(member.currentMedicalPlanName);
                }
            });
            Array.from(fallbackPlanNames).forEach((alias, index) => {
                currentPlans.push({
                    id: index + 1,
                    alias,
                    selectedPlan: "",
                    isBasePlan: false,
                });
            });
        }

        const normalizedBasePlanRow = baseRows.length === 1 ? baseRows[0] : null;
        const normalizedFundingType = fundingTypes.size === 1 ? Array.from(fundingTypes)[0] : null;

        const normalizedRateType = this._isLevelFundedSelected(normalizedFundingType)
            ? "composite"
            : this._getNormalizedCurrentPlansRateType(quote.currentPlansRateType);

        return {
            currentPlans,
            mappedPlansByRow,
            currentPlanSelectionByRow,
            mappedPlanOptions,
            currentPlansBasePlanRow: normalizedBasePlanRow,
            currentPlansRateType: normalizedRateType,
            currentPlansFundingType: normalizedFundingType,
            savedCurrentPlansFundingType: normalizedFundingType,
            currentPlansCarrier: "All Carriers",
            savedCurrentPlansCarrier: "All Carriers",
        };
    };

    _buildCurrentPlansModalSnapshot = ({
        currentPlans = this.state.currentPlans,
        mappedPlansByRow = this.state.mappedPlansByRow,
        currentPlanSelectionByRow = this.state.currentPlanSelectionByRow,
        currentPlansRateType = this.state.currentPlansRateType,
        currentPlansBasePlanRow = this.state.currentPlansBasePlanRow,
    } = {}) => ({
        currentPlans: (currentPlans || []).map(plan =>
            typeof plan === "string" ? plan : { ...plan },
        ),
        mappedPlansByRow: Object.keys(mappedPlansByRow || {}).reduce((acc, key) => {
            const row = mappedPlansByRow[key];
            acc[key] = {
                ...row,
                rates: row && row.rates ? { ...row.rates } : { ...DEFAULT_COMPOSITE_RATES },
            };
            return acc;
        }, {}),
        currentPlanSelectionByRow: Object.keys(currentPlanSelectionByRow || {}).reduce(
            (acc, key) => {
                acc[key] = { ...(currentPlanSelectionByRow[key] || {}) };
                return acc;
            },
            {},
        ),
        currentPlansRateType,
        currentPlansBasePlanRow,
    });

    _censusFileSelected = file => {
        //check for xls
        const nm = file.name;
        const tp = file.type;
        if (nm.endsWith(".xls") || tp === "application/vnd.ms-excel") {
            toast.error("Please use a valid Excel (.xlsx not .xls) template", { toastId: 1 });
            return;
        }

        this.setState({ censusUpload: file });
    };

    _cancelClicked = () => {
        const { quote } = this.props;
        quote.census = [];
        quote.currentPlans = [];
        quote.censusUploadErrors = null;
        quote.currentMedicalBasePlanId = null;
        this.setState({
            census: [],
            currentCensus: 1,
            censusUpload: null,
            isSubmittingCensus: false,
            isManualCensus: false,
        });
    };

    _submitCensus = () => {
        const { needsISLAndPEPM, censusUpload } = this.state;
        //check for xls
        const nm = censusUpload.name;
        const tp = censusUpload.type;
        if (nm.endsWith(".xls") || tp === "application/vnd.ms-excel") {
            toast.error("Please use a valid Excel (.xlsx not .xls) template", { toastId: 1 });
            return;
        }
        //continue
        if (needsISLAndPEPM) {
            this.setState({
                showModal: true,
                isCopy: false,
                isCopyU: false,
            });
        } else {
            this.setState({ isSubmittingCensus: true });
            this.props.uploadCensus(censusUpload, null);
        }
    };

    _copyClicked = () => {
        const { needsISLAndPEPM } = this.state;
        if (needsISLAndPEPM) {
            this.setState({
                showModal: true,
                isCopy: true,
                isCopyU: false,
            });
        } else {
            this.setState({ loading: true });
            this.props.copyCensus();
        }
    };

    _copyClickedU = () => {
        const { needsISLAndPEPM } = this.state;
        if (needsISLAndPEPM) {
            this.setState({
                showModal: true,
                isCopy: false,
                isCopyU: true,
            });
        } else {
            this.setState({ loading: true });
            this.props.copyCensusU();
        }
    };

    _continueSubmit = () => {
        const { quote } = this.props;
        const {
            needsISLAndPEPM,
            stopLossAmount,
            defaultPEPM,
            defaultNetwork,
            erisa,
            isCopy,
            isCopyU,
            isManualCensus,
        } = this.state;

        this.setState(
            {
                showModal: false,
                isCopy: false,
                isCopyU: false,
                showCurrentPlansModal: false,
            },
            () => {
                if (needsISLAndPEPM && (stopLossAmount < 0 || !defaultPEPM)) {
                    toast.error("Please enter values for ISL / PEPM", { toastId: 1 });
                    return;
                } else {
                    //save the ISL and PEPM values...  then continue with census
                    dataApi
                        .updateISLAndPEPM(
                            quote.id,
                            stopLossAmount,
                            defaultPEPM,
                            defaultNetwork === "" ? "na" : defaultNetwork,
                            erisa,
                        )
                        .then(() => {
                            this.setState(
                                {
                                    needsISLAndPEPM: false,
                                },
                                () => {
                                    if (isCopy) {
                                        this._copyClicked();
                                    } else if (isCopyU) {
                                        this._copyClickedU();
                                    } else if (isManualCensus) {
                                        //do nothing... already on that form
                                    } else {
                                        this._submitCensus();
                                    }
                                },
                            );
                        });
                }
            },
        );
    };

    _showCurrentPlansModal = () => {
        this._loadCurrentPlansCache(); // Trigger cache load

        const currentPlans = this.state.currentPlans || [];
        const mappedPlansByRow = this.state.mappedPlansByRow || {};
        const currentPlanSelectionByRow = this.state.currentPlanSelectionByRow || {};

        const hasMeaningfulAliases = currentPlans.some(plan => {
            if (typeof plan === "string") {
                return plan.trim() !== "";
            }
            return !!(
                plan &&
                ((plan.alias && plan.alias.trim() !== "") || (plan.name && plan.name.trim() !== ""))
            );
        });

        const hasMappings =
            Object.keys(mappedPlansByRow).length > 0 ||
            Object.keys(currentPlanSelectionByRow).some(
                rowId => currentPlanSelectionByRow[rowId] && currentPlanSelectionByRow[rowId].value,
            );

        // Load available carriers from cache
        const availableCarriers = this._getAvailableCarriers();

        // Restore saved funding type and carrier for this open
        const { savedCurrentPlansFundingType, savedCurrentPlansCarrier } = this.state;
        const savedOpenState =
            savedCurrentPlansFundingType !== null && savedCurrentPlansFundingType !== undefined
                ? {
                      currentPlansFundingType: savedCurrentPlansFundingType,
                      currentPlansCarrier: savedCurrentPlansCarrier,
                      currentPlansAvailableCarriers: this._getFundingFilterState(
                          savedCurrentPlansFundingType,
                      ).currentPlansAvailableCarriers,
                  }
                : {
                      currentPlansFundingType: null,
                      currentPlansCarrier: "All Carriers",
                      currentPlansAvailableCarriers: availableCarriers,
                  };

        // Path 1: open with existing state, and snapshot it for cancel restore
        if (currentPlans.length > 0 && (hasMeaningfulAliases || hasMappings)) {
            this.setState({
                showCurrentPlansModal: true,
                currentPlansModalSnapshot: this._buildCurrentPlansModalSnapshot(),
                ...savedOpenState,
                pendingCurrentPlansFundingType: null,
            });
            return;
        }

        // Path 2: first-time bootstrap from census aliases
        const censusData =
            this.state.census && this.state.census.length > 0
                ? this.state.census
                : this.props.quote.census || [];

        const distinctPlans = new Set();
        if (censusData && censusData.length > 0) {
            censusData.forEach(member => {
                if (member.currentMedicalPlanName) {
                    distinctPlans.add(member.currentMedicalPlanName);
                }
            });
        }

        const planEntries = Array.from(distinctPlans).map((planName, index) => ({
            id: index + 1,
            alias: planName,
            selectedPlan: "",
            isBasePlan: false,
        }));

        const nextCurrentPlans = planEntries.length > 0 ? planEntries : [];
        const snapshot = this._buildCurrentPlansModalSnapshot({
            currentPlans: nextCurrentPlans,
            mappedPlansByRow,
            currentPlanSelectionByRow,
            currentPlansRateType: this.state.currentPlansRateType,
            currentPlansBasePlanRow: this.state.currentPlansBasePlanRow,
        });

        this.setState({
            showCurrentPlansModal: true,
            currentPlans: nextCurrentPlans,
            currentPlansModalSnapshot: snapshot,
            ...savedOpenState,
            pendingCurrentPlansFundingType: null,
        });
    };

    _closeCurrentPlansModal = () => {
        const { currentPlansModalSnapshot } = this.state;

        if (!currentPlansModalSnapshot) {
            this.setState({
                showCurrentPlansModal: false,
                // Reset funding type and carrier controls
                currentPlansFundingType: null,
                currentPlansCarrier: "All Carriers",
                currentPlansAvailableCarriers: [],
                pendingCurrentPlansFundingType: null,
            });
            return;
        }

        this.setState({
            showCurrentPlansModal: false,
            currentPlans: currentPlansModalSnapshot.currentPlans,
            mappedPlansByRow: currentPlansModalSnapshot.mappedPlansByRow,
            currentPlanSelectionByRow: currentPlansModalSnapshot.currentPlanSelectionByRow,
            currentPlansRateType: currentPlansModalSnapshot.currentPlansRateType,
            currentPlansBasePlanRow: currentPlansModalSnapshot.currentPlansBasePlanRow,
            currentPlansModalSnapshot: null,
            // Reset funding type and carrier controls
            currentPlansFundingType: null,
            currentPlansCarrier: "All Carriers",
            currentPlansAvailableCarriers: [],
            pendingCurrentPlansFundingType: null,
        });
    };

    _saveCurrentPlansModal = () => {
        if (this._currentPlanAliasRevertedOnBlur) {
            this._currentPlanAliasRevertedOnBlur = false;
            return;
        }

        const { mappedPlansByRow, census, currentPlansBasePlanRow, currentPlans } = this.state;

        const duplicateAliases = this._getDuplicateCurrentPlanAliases(currentPlans);
        if (duplicateAliases.length > 0) {
            toast.error(
                `Plan Alias values must be unique. Duplicate alias: ${duplicateAliases[0]}.`,
                { toastId: "current-plans-duplicate-alias" },
            );
            return;
        }

        const normalizedMappedPlansByRow = Object.keys(mappedPlansByRow || {}).reduce(
            (acc, rowKey) => {
                const row = mappedPlansByRow[rowKey] || {};
                const rowRates = row.rates || DEFAULT_COMPOSITE_RATES;

                acc[rowKey] = {
                    ...row,
                    rates: {
                        EE: this._formatCompositeRate(rowRates.EE),
                        ES: this._formatCompositeRate(rowRates.ES),
                        EC: this._formatCompositeRate(rowRates.EC),
                        EF: this._formatCompositeRate(rowRates.EF),
                    },
                };

                return acc;
            },
            {},
        );

        const mappedPlanOptions = Object.values(normalizedMappedPlansByRow)
            .filter(row => row.mappedPlanId)
            .map(row => ({
                label: row.mappedPlanName,
                value: String(row.mappedPlanId),
                alias: row.alias,
            }));

        const updatedCensus = census.map(cen => {
            let matchedOption = cen.currentMedicalPlanId
                ? mappedPlanOptions.find(opt => opt.value === String(cen.currentMedicalPlanId))
                : null;

            if (!matchedOption) {
                matchedOption = mappedPlanOptions.find(
                    opt => opt.alias === cen.currentMedicalPlanName,
                );
            }

            if (!matchedOption) {
                return {
                    ...cen,
                    currentMedicalPlanId: null,
                    currentMedicalCompositeRate: null,
                };
            }

            return {
                ...cen,
                currentMedicalPlanName: matchedOption.alias,
                currentMedicalPlanId: matchedOption.value,
                currentMedicalCompositeRate: (() => {
                    if (this.state.currentPlansRateType === "age") {
                        return null;
                    }

                    const tierKey = this._getCoverageTierKey(cen.medicalCoverageId);
                    if (!tierKey) {
                        return null;
                    }

                    const mappedRow = Object.values(normalizedMappedPlansByRow).find(
                        row => String(row.mappedPlanId) === String(matchedOption.value),
                    );

                    return mappedRow && mappedRow.rates ? mappedRow.rates[tierKey] || null : null;
                })(),
            };
        });

        const baseMappedRow = currentPlansBasePlanRow
            ? normalizedMappedPlansByRow[currentPlansBasePlanRow]
            : null;

        this.props.quote.currentMedicalBasePlanId =
            baseMappedRow && baseMappedRow.mappedPlanId ? String(baseMappedRow.mappedPlanId) : null;

        this.setState({
            census: updatedCensus,
            mappedPlanOptions,
            mappedPlansByRow: normalizedMappedPlansByRow,
            showCurrentPlansModal: false,
            currentPlansModalSnapshot: null,
            pendingCurrentPlansFundingType: null,
            savedCurrentPlansFundingType: this.state.currentPlansFundingType,
            savedCurrentPlansCarrier: this.state.currentPlansCarrier,
        });
    };

    _toggleBasePlanRow = rowNum => {
        this.setState(prev => {
            const selectedPlan = (prev.currentPlanSelectionByRow[rowNum] || {}).value;
            const mappedPlanId = (prev.mappedPlansByRow[rowNum] || {}).mappedPlanId;
            const isRowMapped = !!(selectedPlan || mappedPlanId);

            if (!isRowMapped) {
                return null;
            }

            return {
                currentPlansBasePlanRow: prev.currentPlansBasePlanRow === rowNum ? null : rowNum,
            };
        });
    };

    _setCurrentPlansRateTypeAge = () => {
        if (this._isLevelFundedSelected(this.state.currentPlansFundingType)) {
            return;
        }
        this.setState({ currentPlansRateType: "age" });
    };

    _setCurrentPlansRateTypeComposite = () => {
        this.setState({ currentPlansRateType: "composite" });
    };

    // ============================================================
    // Methods for Funding Type & Carrier Filtering
    // ============================================================

    /**
     * Extract unique carriers from the currentPlansCache
     *
     * WHAT THIS DOES:
     * Takes the cached list of plans and pulls out every unique "type" (carrier) value.
     * For example, if your plans have type: "Aetna", type: "UnitedHealth", type: "Aetna"
     * This will return ["Aetna", "UnitedHealth"]
     *
     * WHY WE NEED IT:
     * We need to populate the carrier dropdown. We get the list of valid carriers
     * from the plans themselves rather than a separate API call.
     *
     * HOW IT WORKS:
     * 1. Get the cached plans from state
     * 2. Map them to just their "type" field
     * 3. Create a Set() to automatically remove duplicates
     * 4. Convert back to array and sort alphabetically
     * 5. Always include "All Carriers" at the beginning
     */
    _getAvailableCarriers = () => {
        const { currentPlansCache } = this.state;
        if (!currentPlansCache || currentPlansCache.length === 0) {
            return ["All Carriers"];
        }

        // Create a Set of unique carrier types (automatically deduplicates)
        const uniqueCarriers = new Set(currentPlansCache.map(plan => plan.type).filter(Boolean));

        // Convert Set back to array, sort alphabetically, and add "All Carriers" at the start
        const carrierArray = ["All Carriers", ...Array.from(uniqueCarriers).sort()];
        return carrierArray;
    };

    /**
     * Filter plans by both funding type AND carrier
     *
     * WHAT THIS DOES:
     * Takes the cached list of all plans and narrows it down based on:
     * - Funding type: "0" (Fully Insured), "1" (Level Funded), or null (show both)
     * - Carrier: specific carrier name or "All Carriers" (show all)
     *
     * WHY WE NEED IT:
     * The SearchInput components need filtered data so users only see plans
     * that match their selected funding type and carrier.
     *
     * HOW IT WORKS:
     * 1. Get all cached plans
     * 2. If fundingType is set ("0" or "1"), only keep plans matching that value
     * 3. If carrier is set (not "All Carriers"), only keep plans matching that carrier
     * 4. Return the filtered list
     */
    _filterPlansByFundingAndCarrier = (fundingType, carrier) => {
        const { currentPlansCache } = this.state;
        if (!currentPlansCache || currentPlansCache.length === 0) {
            return [];
        }

        let filtered = currentPlansCache;

        // Filter by funding type if one is selected
        if (fundingType !== null && fundingType !== undefined) {
            filtered = filtered.filter(plan => String(plan.levelFunded) === String(fundingType));
        }

        // Filter by carrier if not "All Carriers"
        if (carrier && carrier !== "All Carriers") {
            filtered = filtered.filter(plan => plan.type === carrier);
        }

        return filtered;
    };

    /**
     * Handle when user clicks the "Fully Insured" or "Level Funded" button
     *
     * WHAT THIS DOES:
     * When a user picks a funding type, update the state. Also update the
     * available carriers list since different funding types may have different carriers.
     *
     * WHY WE NEED IT:
     * React state needs to track the user's choice. When they click the button,
     * we update state which triggers a re-render with the filtered plans.
     *
     * HOW IT WORKS:
     * 1. Update currentPlansFundingType in state
     * 2. Recalculate available carriers based on the new funding type
     * 3. Reset carrier to "All Carriers" (since different funding types = different carriers)
     */
    _getFundingFilterState = fundingType => {
        // Get the filtered carriers for this funding type
        const filteredPlans = this._filterPlansByFundingAndCarrier(fundingType, "All Carriers");
        const uniqueCarriers = new Set(filteredPlans.map(plan => plan.type).filter(Boolean));
        const carrierArray = ["All Carriers", ...Array.from(uniqueCarriers).sort()];

        return {
            currentPlansFundingType: fundingType,
            currentPlansAvailableCarriers: carrierArray,
            currentPlansCarrier: "All Carriers",
        };
    };

    _setCurrentPlansFundingType = fundingType => {
        const { currentPlansFundingType, pendingCurrentPlansFundingType } = this.state;

        if (pendingCurrentPlansFundingType !== null) {
            return;
        }

        if (String(currentPlansFundingType) === String(fundingType)) {
            return;
        }

        if (currentPlansFundingType === null || currentPlansFundingType === undefined) {
            const nextState = this._getFundingFilterState(fundingType);
            this.setState({
                ...nextState,
                ...(this._isLevelFundedSelected(fundingType)
                    ? { currentPlansRateType: "composite" }
                    : {}),
            });
            return;
        }

        // Only show confirmation popup if there are mapped plans that would be affected
        const { mappedPlansByRow } = this.state;
        if (mappedPlansByRow && Object.keys(mappedPlansByRow).length > 0) {
            this.setState({ pendingCurrentPlansFundingType: fundingType });
        } else {
            const nextState = this._getFundingFilterState(fundingType);
            this.setState({
                ...nextState,
                ...(this._isLevelFundedSelected(fundingType)
                    ? { currentPlansRateType: "composite" }
                    : {}),
            });
        }
    };

    _cancelCurrentPlansFundingSwitch = () => {
        this.setState({ pendingCurrentPlansFundingType: null });
    };

    _confirmCurrentPlansFundingSwitch = () => {
        const { pendingCurrentPlansFundingType, currentPlans } = this.state;

        if (
            pendingCurrentPlansFundingType === null ||
            pendingCurrentPlansFundingType === undefined
        ) {
            return;
        }

        const clearedCurrentPlans = (currentPlans || []).map(plan =>
            typeof plan === "string"
                ? plan
                : {
                      ...plan,
                      selectedPlan: "",
                      isBasePlan: false,
                  },
        );

        this.setState({
            ...this._getFundingFilterState(pendingCurrentPlansFundingType),
            ...(this._isLevelFundedSelected(pendingCurrentPlansFundingType)
                ? { currentPlansRateType: "composite" }
                : {}),
            pendingCurrentPlansFundingType: null,
            currentPlans: clearedCurrentPlans,
            mappedPlansByRow: {},
            currentPlanSelectionByRow: {},
            currentPlansBasePlanRow: null,
        });
    };

    /**
     * Handle when user selects a carrier from the dropdown
     *
     * WHAT THIS DOES:
     * When a user picks a carrier, update the state.
     *
     * WHY WE NEED IT:
     * React state needs to track the user's carrier choice.
     * When they select a carrier, we update state which triggers SearchInput
     * to re-filter and show only plans from that carrier.
     *
     * HOW IT WORKS:
     * 1. Update currentPlansCarrier in state
     * 2. That's it - the SearchInput components will re-filter automatically
     */
    _setCurrentPlansCarrier = carrier => {
        this.setState({ currentPlansCarrier: carrier });
    };

    _addCurrentPlan = () => {
        const { currentPlans } = this.state;
        const newPlan = {
            id: currentPlans.length + 1,
            alias: "",
            selectedPlan: "",
            isBasePlan: false,
        };
        this.setState({
            currentPlans: [...currentPlans, newPlan],
        });
    };

    _loadCurrentPlansCache = () => {
        // Only load if not already cached
        if (this.state.currentPlansCache && this.state.currentPlansCache.length > 0) {
            return Promise.resolve(this.state.currentPlansCache);
        }

        const quoteId = this.props.quote && this.props.quote.id;

        if (!quoteId) {
            return Promise.resolve([]);
        }

        return searchCensusCurrentPlans(quoteId).then(response => {
            const currentPlans = Array.isArray(response) ? response : [];
            this.setState({ currentPlansCache: currentPlans });
            return currentPlans;
        });
    };

    _filterPlans = (term, rowNum) => {
        const { currentPlansFundingType, currentPlansCarrier, mappedPlansByRow } = this.state;
        const normalizedTerm = (term || "").trim().toLowerCase();

        // Collect plan IDs already mapped to OTHER rows so we can exclude them
        const otherRowMappedIds = new Set(
            Object.keys(mappedPlansByRow)
                .filter(key => Number(key) !== Number(rowNum))
                .map(key => String(mappedPlansByRow[key].mappedPlanId))
                .filter(id => !!id),
        );

        // STEP 1: Apply funding type and carrier filters to narrow the dataset
        const filtered = this._filterPlansByFundingAndCarrier(
            currentPlansFundingType,
            currentPlansCarrier,
        );

        // STEP 2: Map the filtered results to the format we need for the SearchInput
        return (
            filtered
                .map(item => ({
                    label: item.label,
                    value: item.value,
                    type: item.type,
                    levelFunded: item.levelFunded,
                }))
                // STEP 3: Exclude plans already mapped to another row
                .filter(option => !otherRowMappedIds.has(String(option.value)))
                // STEP 4: Then apply the search term filter (user's search text in the input box)
                .filter(option => {
                    if (!normalizedTerm) {
                        return true;
                    }
                    return option.label.toLowerCase().indexOf(normalizedTerm) > -1;
                })
        );
    };

    _searchCurrentPlans = (term, rowNum) => {
        const { currentPlansCache } = this.state;

        // If cache is empty, load it first
        if (!currentPlansCache || currentPlansCache.length === 0) {
            return this._loadCurrentPlansCache().then(() => {
                return this._filterPlans(term, rowNum);
            });
        }

        // Otherwise just filter the cached results
        return Promise.resolve(this._filterPlans(term, rowNum));
    };

    _handleCurrentPlanAliasChange = (rowNum, alias) => {
        this.setState(prevState => {
            const nextCurrentPlans = [...(prevState.currentPlans || [])];
            const index = Number(rowNum) - 1;
            const rawPlan = nextCurrentPlans[index];
            const existingPlan =
                typeof rawPlan === "string"
                    ? {
                          id: Number(rowNum),
                          alias: rawPlan,
                          selectedPlan: "",
                          isBasePlan: false,
                      }
                    : rawPlan || {
                          id: Number(rowNum),
                          alias: "",
                          selectedPlan: "",
                          isBasePlan: false,
                      };

            nextCurrentPlans[index] = {
                ...existingPlan,
                alias,
            };

            const existingMappedRow = prevState.mappedPlansByRow[rowNum];

            return {
                currentPlans: nextCurrentPlans,
                mappedPlansByRow: existingMappedRow
                    ? {
                          ...prevState.mappedPlansByRow,
                          [rowNum]: {
                              ...existingMappedRow,
                              alias,
                          },
                      }
                    : prevState.mappedPlansByRow,
            };
        });
    };

    _handleCurrentPlanRowChange = (rowNum, item) => {
        this.setState(
            prevState => {
                const existingRow = prevState.mappedPlansByRow[rowNum] || {};
                const rawPlan = prevState.currentPlans[rowNum - 1];
                const aliasFromCurrentPlans =
                    typeof rawPlan === "string"
                        ? rawPlan
                        : rawPlan && (rawPlan.alias || rawPlan.name)
                        ? rawPlan.alias || rawPlan.name
                        : "";

                const alias = aliasFromCurrentPlans || existingRow.alias || `Plan ${rowNum}`;
                const hasMappedPlan = !!(item && item.value);
                const nextMappedPlansByRow = { ...prevState.mappedPlansByRow };

                if (hasMappedPlan) {
                    nextMappedPlansByRow[rowNum] = {
                        rowNum: Number(rowNum),
                        alias,
                        mappedPlanId: String(item.value),
                        mappedPlanName: item && item.label ? item.label : "",
                        rates: existingRow.rates
                            ? { ...existingRow.rates }
                            : { ...DEFAULT_COMPOSITE_RATES },
                    };
                } else {
                    delete nextMappedPlansByRow[rowNum];
                }

                const nextState = {
                    currentPlanSelectionByRow: {
                        ...prevState.currentPlanSelectionByRow,
                        [rowNum]: {
                            value: hasMappedPlan ? String(item.value) : "",
                            label: hasMappedPlan && item && item.label ? item.label : "",
                        },
                    },
                    mappedPlansByRow: nextMappedPlansByRow,
                };

                if (!hasMappedPlan && prevState.currentPlansBasePlanRow === rowNum) {
                    nextState.currentPlansBasePlanRow = null;
                }

                return nextState;
            },
            () => {
                console.log("After plan row change", {
                    rowNum,
                    currentPlanSelectionByRow: this.state.currentPlanSelectionByRow[rowNum],
                    mappedPlansByRow: this.state.mappedPlansByRow[rowNum],
                });
            },
        );
    };

    _handleCurrentPlanRowTextChange = (rowNum, value) => {
        if (value === "") {
            this.setState(prevState => {
                const nextMappedPlansByRow = { ...prevState.mappedPlansByRow };
                delete nextMappedPlansByRow[rowNum];

                const nextState = {
                    currentPlanSelectionByRow: {
                        ...prevState.currentPlanSelectionByRow,
                        [rowNum]: { value: "", label: "" },
                    },

                    mappedPlansByRow: nextMappedPlansByRow,
                };

                if (prevState.currentPlansBasePlanRow === rowNum) {
                    nextState.currentPlansBasePlanRow = null;
                }

                return nextState;
            });
        }
    };
    _formatCompositeRate = rawValue => {
        const cleaned = String(rawValue || "").replace(/[^0-9.]/g, "");
        if (!cleaned) {
            return "0.00";
        }

        const parts = cleaned.split(".");
        const wholePartRaw = parts[0] || "";
        const decimalRaw = parts.slice(1).join("");

        const wholePart = wholePartRaw === "" ? "0" : String(parseInt(wholePartRaw, 10) || 0);
        const decimalPart = (decimalRaw + "00").slice(0, 2);

        //If they type in over 100k, cap it.
        const numVal = parseFloat(wholePart + "." + decimalPart);
        if (numVal > 99999.99) return "99999.99";

        return wholePart + "." + decimalPart;
    };

    _commitCompositeRate = (rowNum, rateKey) => {
        this.setState(prevState => {
            const row = prevState.mappedPlansByRow[rowNum];
            if (!row) {
                return null;
            }

            const currentValue =
                row.rates && row.rates[rateKey] !== undefined ? row.rates[rateKey] : "";
            const formatted = this._formatCompositeRate(currentValue);

            return {
                mappedPlansByRow: {
                    ...prevState.mappedPlansByRow,
                    [rowNum]: {
                        ...row,
                        rates: {
                            ...row.rates,
                            [rateKey]: formatted,
                        },
                    },
                },
            };
        });
    };

    _handleCompositeRateInputMouseDown = e => {
        // First click into an unfocused input should replace the whole value
        if (document.activeElement !== e.target) {
            e.preventDefault();
            e.target.focus();
            e.target.select();
        }
    };

    _handleCompositeRateInputFocus = e => {
        // Keyboard focus (Tab) should also select all
        e.target.select();
    };

    _handleCompositeRateChange = (rowNum, rateKey, rawValue) => {
        const cleaned = (rawValue || "").replace(/[^0-9.]/g, "");
        const parts = cleaned.split(".");

        // Cap whole part at 5 digits
        const wholePart = parts[0].slice(0, 5);
        const decimalPart =
            parts.length > 1
                ? parts
                      .slice(1)
                      .join("")
                      .slice(0, 2)
                : "";
        const normalized = parts.length > 1 ? `${wholePart}.${decimalPart}` : wholePart;

        this.setState(
            prevState => {
                const row = prevState.mappedPlansByRow[rowNum] || {
                    rowNum,
                    alias:
                        (prevState.currentPlans[rowNum - 1] &&
                            prevState.currentPlans[rowNum - 1].alias) ||
                        `Plan ${rowNum}`,
                    mappedPlanId: (prevState.currentPlanSelectionByRow[rowNum] || {}).value || "",
                    mappedPlanName: (prevState.currentPlanSelectionByRow[rowNum] || {}).label || "",
                    rates: { ...DEFAULT_COMPOSITE_RATES },
                };

                return {
                    mappedPlansByRow: {
                        ...prevState.mappedPlansByRow,
                        [rowNum]: {
                            ...row,
                            rates: {
                                ...row.rates,
                                [rateKey]: normalized,
                            },
                        },
                    },
                };
            },
            () => {
                console.log("After rate change", {
                    rowNum,
                    rateKey,
                    mappedPlansByRow: this.state.mappedPlansByRow[rowNum],
                });
            },
        );
    };

    _confirmClicked = () => {
        //validate that the census is filled in...
        const normalizedCensus = this._normalizeCensusRows(this.state.census);
        if (normalizedCensus && normalizedCensus.length > 0) {
            let cnt = 1;
            let err = false;
            normalizedCensus.forEach(cen => {
                //have values for each field...  cen.homePostalCode === null ||
                if (
                    cen.sequenceNumber === null ||
                    cen.firstName === null ||
                    cen.lastName === null ||
                    cen.firstName.length === 0 ||
                    cen.lastName.length === 0 ||
                    cen.birthDate === null ||
                    cen.gender === null ||
                    //Do we want to allow null currentMedicalPlanName? I feel like yes.
                    //cen.currentMedicalPlanName === null ||
                    cen.medicalCoverageId === null ||
                    cen.dentalCoverageId === null ||
                    cen.visionCoverageId === null ||
                    cen.lifeCoverageId === null ||
                    cen.homePostalCode === null ||
                    cen.homePostalCode.length === 0 ||
                    cen.isPPO === null ||
                    cen.isHMO === null ||
                    cen.isTobacco === null ||
                    cen.onCobra === null
                ) {
                    err = true;
                    toast.error(
                        "No. " + cen.sequenceNumber + ": Cannot submit an incomplete employee row.",
                        { toastId: cnt * 1 },
                    );
                }
                //check specific values for accuracy
                //DOB
                let d = new Date(cen.birthDate);
                if (cen.birthDate.length < 10 || !(d instanceof Date) || isNaN(d.valueOf())) {
                    err = true;
                    toast.error("No. " + cen.sequenceNumber + ": Cannot submit an invalid DOB.", {
                        toastId: cnt * 10,
                    });
                }
                //Enrollment Date
                if (cen.enrollmentDate && cen.enrollmentDate.length > 0) {
                    let ed = new Date(cen.enrollmentDate);
                    if (
                        cen.enrollmentDate.length < 10 ||
                        !(ed instanceof Date) ||
                        isNaN(ed.valueOf())
                    ) {
                        err = true;
                        toast.error(
                            "No. " +
                                cen.sequenceNumber +
                                ": Cannot submit an invalid Enrollment Date.",
                            {
                                toastId: cnt * 15,
                            },
                        );
                    }
                }
                //H Zip
                if (!/^\d{5}$/.test(cen.homePostalCode)) {
                    err = true;
                    toast.error("No. " + cen.sequenceNumber + ": Cannot submit an invalid H Zip.", {
                        toastId: cnt * 20,
                    });
                }
                //W Zip
                if (
                    cen.workPostalCode !== null &&
                    cen.workPostalCode.length > 0 &&
                    !/^\d{5}$/.test(cen.workPostalCode)
                ) {
                    err = true;
                    toast.error("No. " + cen.sequenceNumber + ": Cannot submit an invalid W Zip.", {
                        toastId: cnt * 30,
                    });
                }
                //dependent rows
                if (cen.dependents && cen.dependents.length > 0) {
                    cen.dependents.forEach(dep => {
                        //have values for each field...
                        if (
                            dep.sequenceNumber === null ||
                            dep.firstName === null ||
                            dep.lastName === null ||
                            dep.firstName.length === 0 ||
                            dep.lastName.length === 0 ||
                            dep.birthDate === null ||
                            dep.gender === null ||
                            dep.homePostalCode === null ||
                            dep.homePostalCode.length === 0 ||
                            dep.isTobacco === null ||
                            dep.onCobra === null
                        ) {
                            err = true;
                            toast.error(
                                "No. " +
                                    dep.sequenceNumber +
                                    ": Cannot submit an incomplete dependent row.",
                                { toastId: cnt * 40 },
                            );
                        }
                        //check specific values for accuracy
                        //DOB
                        let d = new Date(dep.birthDate);
                        if (
                            dep.birthDate.length < 10 ||
                            !(d instanceof Date) ||
                            isNaN(d.valueOf())
                        ) {
                            err = true;
                            toast.error(
                                "No. " + dep.sequenceNumber + ": Cannot submit an invalid DOB.",
                                { toastId: cnt * 50 },
                            );
                        }
                        //H Zip
                        if (!/^\d{5}$/.test(dep.homePostalCode)) {
                            err = true;
                            toast.error(
                                "No. " + dep.sequenceNumber + ": Cannot submit an invalid H Zip.",
                                { toastId: cnt * 60 },
                            );
                        }
                    });
                }
                //increment
                cnt++;
            });

            //passed?
            if (!err) {
                this.setState({
                    isSubmittingCensus: true,
                    census: normalizedCensus,
                });

                if (this.props.quote.census && this.props.quote.census.length > 0) {
                    this.props.quote.census = this._normalizeCensusRows(this.props.quote.census);
                    // use quote-owned census + quote-owned base plan in parent method
                    this.props.uploadCensus(null, null, null, null); //this will upload the quote.census, which we are setting manually through props...
                } else {
                    // manual branch computes from current modal state

                    const currentMedicalMappedPlans = Object.values(
                        this.state.mappedPlansByRow || {},
                    )
                        .filter(row => row && row.mappedPlanId)
                        .map(row => ({
                            alias: row.alias || null,
                            currentMedicalPlanId: String(row.mappedPlanId),
                            currentMedicalCompositeECRate:
                                row.rates && row.rates.EC !== undefined ? row.rates.EC : null,
                            currentMedicalCompositeEERate:
                                row.rates && row.rates.EE !== undefined ? row.rates.EE : null,
                            currentMedicalCompositeEFRate:
                                row.rates && row.rates.EF !== undefined ? row.rates.EF : null,
                            currentMedicalCompositeESRate:
                                row.rates && row.rates.ES !== undefined ? row.rates.ES : null,
                        }));

                    const baseRow = this.state.currentPlansBasePlanRow;
                    const baseMappedRow = baseRow ? this.state.mappedPlansByRow[baseRow] : null;
                    const currentMedicalBasePlanId =
                        baseMappedRow && baseMappedRow.mappedPlanId
                            ? String(baseMappedRow.mappedPlanId)
                            : null;

                    this.props.uploadCensus(
                        null,
                        normalizedCensus,
                        currentMedicalBasePlanId,
                        currentMedicalMappedPlans,
                        this.state.currentPlansRateType,
                    ); //this will upload the manual (from scratch) census.
                }
            }
        } else {
            toast.error("Cannot submit an incomplete census.", { toastId: 1 });
        }
    };

    _addCensusManually = () => {
        const { needsISLAndPEPM } = this.state;
        //need to gather?
        if (needsISLAndPEPM) {
            this.setState({
                showModal: true,
                isCopy: false,
                isCopyU: false,
            });
        }
        //move to manual census
        this.setState({ isManualCensus: true });
    };

    _quickAddCensus = () => {
        const { quote } = this.props;
        const { needsISLAndPEPM, currentCensus } = this.state;

        //for creating 20 year old census members
        const oneDayBefore = new Date(quote.effectiveDate);
        oneDayBefore.setDate(oneDayBefore.getDate() - 1);

        const dob = new Date(oneDayBefore);
        dob.setFullYear(dob.getFullYear() - 20);

        //fill in census with random members to match the Total Number of Employees on Payroll
        let newCensus = [];
        let newCurrentCensusCount = currentCensus;
        for (let i = 0; i < quote.totalNumberEligibleEmployees; i++) {
            //create new census member
            const newCensusMember = {
                quoteId: quote.id,
                employerId: quote.employerId,
                sequenceNumber: newCurrentCensusCount.toString(),
                relationship: "EE",
                firstName: "Employee",
                lastName: newCurrentCensusCount.toString(),
                birthDate: dob.toLocaleDateString("es-pa"),
                gender: "M",
                medicalCoverageId: 1,
                dentalCoverageId: 1,
                visionCoverageId: 1,
                lifeCoverageId: 1,
                homePostalCode: quote.zip,
                workPostalCode: "",
                occupation: "",
                salary: "",
                isPPO: true,
                isHMO: true,
                isTobacco: false,
                onCobra: false,
                dependents: [],
            };
            //incrememnt
            newCurrentCensusCount++;
            //add to local object
            newCensus.push(newCensusMember);
        }
        //need to gather ISL and PEPM?
        if (needsISLAndPEPM) {
            this.setState({
                showModal: true,
                isCopy: false,
                isCopyU: false,
            });
        }
        //save census and move to manual census page
        this.setState({
            census: newCensus,
            currentCensus: newCurrentCensusCount,
            isManualCensus: true,
        });
    };

    _addCensusMember = () => {
        const { quote } = this.props;
        const { currentCensus } = this.state;
        const newCensus = {
            quoteId: quote.id,
            employerId: quote.employerId,
            sequenceNumber: currentCensus.toString(),
            relationship: "EE",
            firstName: "",
            lastName: "",
            birthDate: "",
            gender: "M",
            currentMedicalPlanName: "",
            medicalCoverageId: 1,
            dentalCoverageId: 1,
            visionCoverageId: 1,
            lifeCoverageId: 1,
            homePostalCode: "",
            workPostalCode: "",
            occupation: "",
            salary: "",
            isPPO: true,
            isHMO: true,
            isTobacco: false,
            onCobra: false,
            dependents: [],
        };
        const joined = this.state.census.concat(newCensus);
        this.setState({
            census: joined,
            currentCensus: currentCensus + 1,
        });
    };

    _removeCurrentPlanRow = rowNum => {
        this.setState(prevState => {
            // Remove by position (index), not by plan.id
            const updatedCurrentPlans = prevState.currentPlans.filter(
                (_, idx) => idx + 1 !== rowNum,
            );

            // Re-number the remaining plans so plan.id stays sequential
            const renumberedPlans = updatedCurrentPlans.map((plan, idx) => {
                if (typeof plan === "string") {
                    return plan;
                }
                return Object.assign({}, plan, { id: idx + 1 });
            });

            // Re-index mappedPlansByRow: shift keys above rowNum down by 1
            const reindexedMapped = {};
            Object.keys(prevState.mappedPlansByRow).forEach(key => {
                const k = Number(key);
                if (k === rowNum) return; // drop the removed row
                const newKey = k > rowNum ? k - 1 : k;
                reindexedMapped[newKey] = Object.assign({}, prevState.mappedPlansByRow[k], {
                    rowNum: newKey,
                });
            });

            // Re-index currentPlanSelectionByRow the same way
            const reindexedSelection = {};
            Object.keys(prevState.currentPlanSelectionByRow).forEach(key => {
                const k = Number(key);
                if (k === rowNum) return;
                const newKey = k > rowNum ? k - 1 : k;
                reindexedSelection[newKey] = prevState.currentPlanSelectionByRow[k];
            });

            // Shift basePlanRow if it was above the removed row
            let newBasePlanRow = prevState.currentPlansBasePlanRow;
            if (newBasePlanRow === rowNum) {
                newBasePlanRow = null;
            } else if (newBasePlanRow > rowNum) {
                newBasePlanRow = newBasePlanRow - 1;
            }

            return {
                currentPlans: renumberedPlans,
                mappedPlansByRow: reindexedMapped,
                currentPlanSelectionByRow: reindexedSelection,
                currentPlansBasePlanRow: newBasePlanRow,
            };
        });
    };

    _removeCensusMember = c => {
        if (!this.state.census) {
            this.setState({ census: [], currentCensus: 1 });
        } else {
            const matchC = this.state.census.find(cen => cen.sequenceNumber === c.sequenceNumber);
            if (matchC) {
                const spliced = [...this.state.census];
                const index = spliced.indexOf(matchC);
                if (index > -1) {
                    spliced.splice(index, 1);
                    this.setState(
                        {
                            census: spliced,
                        },
                        () => {
                            this._reNumberCensus();
                        },
                    );
                }
            }
        }
    };

    _addDependent = c => {
        const lngth = (c.dependents.length + 1).toString();
        const rel = c.medicalCoverageId === "3" ? "C" : lngth === "1" ? "SP" : "C";
        const newDep = {
            sequenceNumber: c.sequenceNumber + "." + lngth,
            relationship: rel,
            dependentType:
                c.medicalCoverageId === "3" ? "Child" : lngth === "1" ? "Spouse" : "Child",
            firstName: "",
            lastName: "",
            birthDate: "",
            gender: "M",
            homePostalCode: c.homePostalCode,
            isTobacco: false,
            childDependentStatus: rel === "C" ? "Child" : null,
        };
        const joined = c.dependents.concat(newDep);

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber
                    ? { ...person, dependents: joined }
                    : person,
            ),
        });
    };

    _removeDependent = (c, d) => {
        const matchC = this.state.census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC && matchC.dependents.length > 0) {
            const matchD = matchC.dependents.find(dep => dep.sequenceNumber === d.sequenceNumber);
            if (matchD) {
                const spliced = [...matchC.dependents];
                const index = matchC.dependents.indexOf(matchD);
                if (index > -1) {
                    spliced.splice(index, 1);
                    this.setState(
                        {
                            census: this.state.census.map(person =>
                                person.sequenceNumber === c.sequenceNumber
                                    ? { ...person, dependents: spliced }
                                    : person,
                            ),
                        },
                        () => {
                            this._reNumberCensus();
                        },
                    );
                }
            }
        }
    };

    _reNumberCensus = () => {
        const { census } = this.state;
        if (census && census.length > 1) {
            //make a copy
            let updated = [...census];
            for (let i = 0; i < updated.length; i++) {
                updated[i].sequenceNumber = (i + 1).toString();
                if (updated[i].dependents && updated[i].dependents.length > 0) {
                    for (let j = 0; j < updated[i].dependents.length; j++) {
                        updated[i].dependents[j].sequenceNumber =
                            (i + 1).toString() + "." + (j + 1).toString();
                    }
                }
            }
            this.setState({
                census: updated,
                currentCensus: updated.length + 1,
            });
        }
    };

    _handleTextChanged = e => {
        const { name } = e.target;
        let { value } = e.target;

        if (e.target.getAttribute("data-type") === "date") {
            value = "";
        }

        this.setState(prevState => {
            const errors = { ...prevState.errors };
            delete errors[name];

            return {
                inputs: {
                    ...prevState.inputs,
                    [name]: value,
                },
                errors,
            };
        });
    };

    _handleDropdownChanged = selectedItem => {
        const { name, value } = selectedItem;

        this.setState(prevState => {
            return {
                inputs: {
                    ...prevState.inputs,
                    [name]: value,
                },
            };
        });
    };

    _setRelationship = (e, c, d) => {
        const val = e.value;
        const val2 = val === "SP" ? "Spouse" : "Child";
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.relationship = val;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, relationship: val }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.relationship = val;
                    matchD.dependentType = val2;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, relationship: val, dependentType: val2 }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setFirstName = (e, c, d) => {
        const val = e.target.value;
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.firstName = val;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, firstName: val }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.firstName = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, firstName: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setLastName = (e, c, d) => {
        const val = e.target.value;
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.lastName = val;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, lastName: val }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.lastName = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, lastName: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setDOB = (e, c, d) => {
        //valid date
        const val = util.maskDate(e.target.value);
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.birthDate = val;
                matchC.birthDateString = val;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, birthDate: val, birthDateString: val }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.birthDate = val;
                    matchD.birthDateString = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, birthDate: val, birthDateString: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setDOH = (e, c) => {
        //valid date
        const val = util.maskDate(e.target.value);
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census
        if (matchC) {
            matchC.hireDate = val;
            matchC.hireDateString = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber
                    ? { ...person, hireDate: val, hireDateString: val }
                    : person,
            ),
        });
    };

    _setEnrollmentDate = (e, c) => {
        //valid date
        const val = util.maskDate(e.target.value);
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census
        if (matchC) {
            matchC.enrollmentDate = val;
            matchC.enrollmentDateString = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber
                    ? { ...person, enrollmentDate: val, enrollmentDateString: val }
                    : person,
            ),
        });
    };

    _setGender = (e, c, d) => {
        const val = e.value;
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.gender = val;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, gender: val }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.gender = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, gender: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setChildDependentStatus = (e, c, d) => {
        const val = e.value;
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            const matchD = matchC.dependents.find(dep => dep.sequenceNumber === d.sequenceNumber);
            if (matchD) {
                matchD.childDependentStatus = val;
            }
        }

        this.setState(prevState => ({
            census: prevState.census.map(cen => {
                if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                    return {
                        ...cen,
                        dependents: cen.dependents.map(person =>
                            person.sequenceNumber === d.sequenceNumber
                                ? { ...person, childDependentStatus: val }
                                : person,
                        ),
                    };
                }
                return cen;
            }),
        }));
    };

    _getCoverageTierKey = medicalCoverageId => {
        switch (String(medicalCoverageId)) {
            case "1":
                return "EE";
            case "2":
                return "ES";
            case "3":
                return "EC";
            case "4":
                return "EF";
            case "5":
                return null; // waive/no tier
            default:
                return null;
        }
    };

    _getCompositeRateForSelection = ({ medicalCoverageId, currentMedicalPlanId }) => {
        const { currentPlansRateType, mappedPlansByRow } = this.state;

        if (currentPlansRateType === "age") {
            return null;
        }

        const tierKey = this._getCoverageTierKey(medicalCoverageId);
        if (!tierKey) {
            return null;
        }

        const mappedRow = Object.values(mappedPlansByRow || {}).find(
            row => String(row.mappedPlanId) === String(currentMedicalPlanId),
        );

        if (!mappedRow || !mappedRow.rates) {
            return null;
        }

        return mappedRow.rates[tierKey] || null;
    };

    _handleMappedPlanSelect = (selected, cen) => {
        const selectedOption = this.state.mappedPlanOptions.find(
            opt => opt.value === selected.value,
        );
        this._setcurrentMedicalPlanName(
            {
                value: selectedOption ? selectedOption.alias : "",
            },
            cen,
            null,
        );
        this.setState(
            prevState => ({
                census: prevState.census.map(person =>
                    person.sequenceNumber === cen.sequenceNumber
                        ? {
                              ...person,
                              currentMedicalPlanId: selected.value,
                              currentMedicalCompositeRate: this._getCompositeRateForSelection({
                                  medicalCoverageId: person.medicalCoverageId,
                                  currentMedicalPlanId: selected.value,
                              }),
                          }
                        : person,
                ),
            }),
            () =>
                console.log(
                    "Composite debug: mapped plan changed",
                    this.state.census.find(person => person.sequenceNumber === cen.sequenceNumber),
                ),
        );
    };

    _setcurrentMedicalPlanName = (e, c) => {
        const val = e.value;
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census
        if (matchC) {
            matchC.currentMedicalPlanName = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber
                    ? { ...person, currentMedicalPlanName: val }
                    : person,
            ),
        });
    };

    _setMedicalCoverage = (e, c, d) => {
        const val = e.value;
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.medicalCoverageId = val;
            }

            this.setState(
                {
                    census: this.state.census.map(person =>
                        person.sequenceNumber === c.sequenceNumber
                            ? {
                                  ...person,
                                  medicalCoverageId: val,
                                  currentMedicalCompositeRate: this._getCompositeRateForSelection({
                                      medicalCoverageId: val,
                                      currentMedicalPlanId: person.currentMedicalPlanId,
                                  }),
                              }
                            : person,
                    ),
                },
                () =>
                    console.log(
                        "Composite debug: medical coverage changed",
                        this.state.census.find(
                            person => person.sequenceNumber === c.sequenceNumber,
                        ),
                    ),
            );
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.medicalCoverageId = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, medicalCoverageId: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setDentalCoverage = (e, c, d) => {
        const val = e.value;
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.dentalCoverageId = val;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, dentalCoverageId: val }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.dentalCoverageId = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, dentalCoverageId: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setVisionCoverage = (e, c, d) => {
        const val = e.value;
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.visionCoverageId = val;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, visionCoverageId: val }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.visionCoverageId = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, visionCoverageId: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setLifeCoverage = (e, c, d) => {
        const val = e.value;
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.lifeCoverageId = val;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, lifeCoverageId: val }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.lifeCoverageId = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, lifeCoverageId: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setHZip = (e, c, d) => {
        //valid postal code
        let val = e.target.value;
        val = val.replace(/[^0-9]+/g, "");
        if (val && val.length === 6) {
            return;
        }

        if (d !== null && !ENABLE_DEPENDENT_ZIP_EDIT) {
            return;
        }

        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.homePostalCode = val;
                if (!ENABLE_DEPENDENT_ZIP_EDIT && matchC.dependents) {
                    matchC.dependents = matchC.dependents.map(dep => ({
                        ...dep,
                        homePostalCode: val,
                    }));
                }
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? {
                              ...person,
                              homePostalCode: val,
                              dependents: !ENABLE_DEPENDENT_ZIP_EDIT
                                  ? (person.dependents || []).map(dep => ({
                                        ...dep,
                                        homePostalCode: val,
                                    }))
                                  : person.dependents,
                          }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.homePostalCode = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, homePostalCode: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setWZip = (e, c) => {
        //valid postal code
        let val = e.target.value;
        val = val.replace(/[^0-9]+/g, "");
        if (val && val.length === 6) {
            return;
        }
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            matchC.workPostalCode = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber
                    ? { ...person, workPostalCode: val }
                    : person,
            ),
        });
    };

    _setOccupation = (e, c) => {
        const val = e.target.value;
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            matchC.occupation = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber
                    ? { ...person, occupation: val }
                    : person,
            ),
        });
    };

    _setEmail = (e, c) => {
        const val = e.target.value;
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            matchC.email = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber ? { ...person, email: val } : person,
            ),
        });
    };

    _setSalary = (e, c) => {
        //valid number
        let val = e.target.value;
        val = val.replace(/[^0-9]+/g, "");
        if (val && val.length === 7) {
            return;
        }
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            matchC.salary = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber ? { ...person, salary: val } : person,
            ),
        });
    };

    /*
    _setTobacco = (e, c, d) => {
        const val = e.value === "1" ? true : false;
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.isTobacco = val;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, isTobacco: val }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.isTobacco = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, isTobacco: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };
    */

    /*
    _setCOB = (e, c) => {
        const val = e.value === "1" ? true : false;
        const { census } = this.props.quote;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            matchC.onCobra = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber ? { ...person, onCobra: val } : person,
            ),
        });
    };
    */

    _handleISLChanged = selectedItem => {
        this.setState({
            stopLossAmount: selectedItem.value,
        });
    };

    _fileDropped = droppedFiles => {
        //check for xls
        const nm = droppedFiles[0].name;
        const tp = droppedFiles[0].type;
        if (nm.endsWith(".xls") || tp === "application/vnd.ms-excel") {
            toast.error("Please use a valid Excel (.xlsx not .xls) template", { toastId: 1 });
            return;
        }
        //continue
        this.setState({ censusUpload: droppedFiles[0] });
    };

    _handlePEPMChanged = e => {
        let val = e.target.value;
        val = val.replace(/[^0-9]+/g, "");
        if (val.length > 3) {
            return;
        }

        this.setState({
            defaultPEPM: val,
        });
    };

    _handleNetworkChanged = selectedItem => {
        this.setState({
            defaultNetwork: selectedItem.value,
        });
    };

    _handleErisaChanged = selectedItem => {
        const val = selectedItem.value === "1" ? true : false;
        this.setState({
            erisa: val,
        });
    };

    _toggleAllPlanCheckboxes = (planType, checkAll) => e => {
        e.preventDefault();
        // Your toggle logic here
        console.log(`Toggle ${planType} to ${checkAll}`);
        // Add your logic to check/uncheck all checkboxes for this plan type

        const fieldMap = {
            PPO: "isPPO",
            HMO: "isHMO",
            COBRA: "onCobra",
            TOB: "isTobacco",
        };

        const field = fieldMap[planType];

        this.setState(prevState => ({
            census: prevState.census.map(person => {
                const updated = { ...person, [field]: checkAll };

                // For tobacco, also update dependents
                if (field === "isTobacco" && person.dependents && person.dependents.length > 0) {
                    updated.dependents = person.dependents.map(dep => ({
                        ...dep,
                        isTobacco: checkAll,
                    }));
                }

                return updated;
            }),
        }));
    };

    _handleInputChange = (e, c, d = null) => {
        const { checked, name, type, value } = e.target;
        const val = type === "checkbox" ? checked : value;

        const fieldMap = {
            [inputNames.isPPO]: "isPPO",
            [inputNames.isHMO]: "isHMO",
            [inputNames.onCobra]: "onCobra",
            [inputNames.isTobacco]: "isTobacco",
        };

        const field = fieldMap[name];
        if (!field) {
            return;
        }

        this.setState(prevState => ({
            census: prevState.census.map(person => {
                if (person.sequenceNumber !== c.sequenceNumber) {
                    return person;
                }

                if (d === null) {
                    return { ...person, [field]: val };
                }

                // Only TOB should hit dependent row from current UI usage.
                if (field !== "isTobacco") {
                    return person;
                }

                return {
                    ...person,
                    dependents: person.dependents.map(dep =>
                        dep.sequenceNumber === d.sequenceNumber ? { ...dep, [field]: val } : dep,
                    ),
                };
            }),
        }));
        /*
        const { checked, name, type, value } = e.target;
        const val = type === "checkbox" ? checked : value;

        // --- Hub Permissions --------------------------------------------------------
        //check Hub Quoting permission change
        if (name === "ratingEngineQuotePermission" && value === "on") {
            //check to make sure we ALREADY have the Hub permission
            if (!this.state.inputs[inputNames.ratingEnginePermission]) {
                toast.error("Cannot add Quoting permission before adding Rating Engine access.", {
                    toastId: 1,
                });
                return;
            }
        }
        //check Hub permission change... turn off Quoting if ALSO removing Hub permission
        if (name === "ratingEnginePermission" && value === "off") {
            //check to make sure we ALREADY have the Hub permission
            if (this.state.inputs[inputNames.ratingEngineQuotePermission]) {
                this.setState(
                    prevState => {
                        return {
                            inputs: {
                                ...prevState.inputs,
                                [inputNames.ratingEngineQuotePermission]: false,
                                [name]: val,
                            },
                        };
                    },
                    () => {
                        this._handleOnSave();
                    },
                );
                return;
            }
        }
        // --- Hub Permissions --------------------------------------------------------

        //normal save
        this.setState(
            prevState => {
                return {
                    inputs: {
                        ...prevState.inputs,
                        [name]: val,
                    },
                };
            },
            () => {
                this._handleOnSave();
            },
        );
                */
    };

    render() {
        const { quote } = this.props;
        const {
            census,
            //Todo: Figure out what I was going to do with this:
            //currentPlans,
            isSubmittingCensus,
            isManualCensus,
            showModal,
            showCurrentPlansModal,
            stopLossAmounts,
            stopLossAmount,
            defaultPEPM,
            networks,
            defaultNetwork,
            showErisa,
            erisa,
            currentPlansRateType,
            currentPlansFundingType,
        } = this.state;

        const isLevelFundedSelected = this._isLevelFundedSelected(currentPlansFundingType);
        const CURRENT_PLANS_MODAL_TAB_BASE = 50000;
        const currentPlansRowCount =
            (this.state.currentPlans && this.state.currentPlans.length) || 1;
        const CURRENT_PLANS_TAB_STRIDE_PER_ROW = 3;
        const currentPlansGridTabStart = CURRENT_PLANS_MODAL_TAB_BASE + 100;
        const currentPlansRateTabStart =
            currentPlansGridTabStart + currentPlansRowCount * CURRENT_PLANS_TAB_STRIDE_PER_ROW;

        const MEMBER_TAB_FIELD_COUNT = 16;
        const DEPENDENT_TAB_FIELD_COUNT = ENABLE_DEPENDENT_ZIP_EDIT ? 7 : 6;
        const censusTabBases = [];
        let nextCensusTabBase = 0;

        (census || []).forEach(member => {
            censusTabBases.push(nextCensusTabBase);
            nextCensusTabBase +=
                MEMBER_TAB_FIELD_COUNT +
                (member.dependents || []).length * DEPENDENT_TAB_FIELD_COUNT;
        });

        const Hover = ({ onHover, children }) => (
            <div className={css(styles.hover)}>
                <div className={css(styles.__nohover)}>{children}</div>
                <div className={css(styles.__hover)}>{onHover}</div>
            </div>
        );

        const getCurrentPlanHoverText = cen => {
            if (this.state.mappedPlanOptions && this.state.mappedPlanOptions.length > 0) {
                const selectedMapped = cen.currentMedicalPlanId
                    ? this.state.mappedPlanOptions.find(
                          opt => String(opt.value) === String(cen.currentMedicalPlanId),
                      )
                    : null;
                if (selectedMapped && selectedMapped.label) {
                    return selectedMapped.label;
                }
                const selectedByAlias = this.state.mappedPlanOptions.find(
                    opt => opt.alias === cen.currentMedicalPlanName,
                );
                if (selectedByAlias && selectedByAlias.label) {
                    return selectedByAlias.label;
                }
            }

            return cen.currentMedicalPlanName || "No current plan selected";
        };

        return (
            <div className={css(styles.censusContainer)}>
                <style>{`.census-upload-alert-icon rect { fill: ${color.red} !important; }`}</style>
                <ToastContainer position="top-center" autoClose={2500} />
                {isSubmittingCensus && (
                    <div className={css(styles.censusLoading)}>
                        <Spinner aStyles={styles.loadingSpinner} text="Uploading..." />
                    </div>
                )}
                {!isSubmittingCensus && quote.lastEnrollmentCensusSize > 0 && !isManualCensus && (
                    <React.Fragment>
                        <div className={css(styles.censusHeaderU)}>
                            <div className={css(styles.censusHeaderText)}>
                                We have an existing census from a UBenefit enrollment (last updated
                                on {format(quote.lastEnrollmentDateWithCensus, "MM/DD/YYYY")}) with{" "}
                                {quote.lastEnrollmentCensusSize} employees.
                            </div>
                            <ActionButton
                                aStyles={styles.useExistingContainer}
                                disabled={this.state.loading}
                                label={strings.useExistingCensusButton}
                                onClick={this._copyClickedU}
                                type="button"
                            />
                        </div>
                    </React.Fragment>
                )}
                {!isSubmittingCensus && quote.lastQuoteCensusSize > 0 && !isManualCensus && (
                    <React.Fragment>
                        <div className={css(styles.censusHeader)}>
                            <div className={css(styles.censusHeaderText)}>
                                We have an existing census from Quote{" "}
                                {quote.lastQuoteNumberWithCensus} (created on{" "}
                                {format(quote.lastQuoteDateWithCensus, "MM/DD/YYYY")}) with{" "}
                                {quote.lastQuoteCensusSize} employees.
                            </div>
                            <ActionButton
                                aStyles={styles.useExistingContainer}
                                disabled={this.state.loading}
                                label={strings.useExistingCensusButton}
                                onClick={this._copyClicked}
                                type="button"
                            />
                        </div>
                        <div className={css(styles.censusOptionsText)}>
                            {strings.censusOptionsLabel}
                        </div>
                    </React.Fragment>
                )}
                {/*Census Copy or Upload*/}
                {!isSubmittingCensus && !isManualCensus && (
                    <div className={css(styles.censusOptionsContainer)}>
                        <Container>
                            <Row>
                                <Column large={this.state.censusUpload === null ? 5 : 12}>
                                    <div className={css(styles.censusOptionItem)}>
                                        <div className={css(styles.censusOptionItemHeader)}>
                                            <div className={css(styles.censusOptionItemHeaderText)}>
                                                {strings.loadCensus}
                                            </div>
                                            {this.state.censusUpload === null && (
                                                <a
                                                    className={css(styles.downloadTemplateIcon)}
                                                    href="/files/census_import.xlsx"
                                                >
                                                    {strings.downloadTemplate}
                                                    <DownloadIcon
                                                        className={css(styles.downloadIcon)}
                                                    />
                                                </a>
                                            )}
                                            <div
                                                className={css(
                                                    styles.censusButton,
                                                    styles.loadCensusButton,
                                                    this.state.censusUpload !== null
                                                        ? styles.censusFileSelected
                                                        : null,
                                                )}
                                            >
                                                <UploadIcon
                                                    className={css(
                                                        styles.censusIcon,
                                                        styles.uploadIcon,
                                                        this.state.censusUpload !== null
                                                            ? styles.censusUploadedIcon
                                                            : null,
                                                    )}
                                                />
                                                {this.state.censusUpload === null ? (
                                                    <Dropzone onDrop={this._fileDropped}>
                                                        {({ getRootProps, getInputProps }) => (
                                                            <div {...getRootProps()}>
                                                                <input {...getInputProps()} />
                                                                <div
                                                                    className={css(
                                                                        styles.censusButtonText,
                                                                    )}
                                                                >
                                                                    Drop your census file here or{" "}
                                                                    <FileBrowser
                                                                        onSelect={
                                                                            this._censusFileSelected
                                                                        }
                                                                        disableClick={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Dropzone>
                                                ) : (
                                                    <React.Fragment>
                                                        <div
                                                            className={css(styles.censusButtonText)}
                                                        >
                                                            Your File:
                                                        </div>
                                                        <div
                                                            className={css(
                                                                styles.censusSelectedButtonText,
                                                            )}
                                                        >
                                                            {this.state.censusUpload.name}
                                                        </div>
                                                        <CancelIcon
                                                            className={css(
                                                                styles.clearCensusButton,
                                                            )}
                                                            onClick={this._cancelClicked}
                                                        />
                                                    </React.Fragment>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Column>
                                {this.state.censusUpload === null && (
                                    <React.Fragment>
                                        <Column large={2}>
                                            <div
                                                className={css(
                                                    styles.censusOptionSeparatorTextContainer,
                                                )}
                                            >
                                                &mdash; OR &mdash;
                                            </div>
                                        </Column>
                                        <Column large={5}>
                                            <div className={css(styles.censusOptionItem)}>
                                                <div className={css(styles.censusOptionItemHeader)}>
                                                    <div
                                                        className={css(
                                                            styles.censusOptionItemHeaderText,
                                                        )}
                                                    >
                                                        {strings.createCensus}
                                                    </div>
                                                </div>
                                                <div
                                                    className={css(
                                                        styles.censusButton,
                                                        styles.createCensusButton,
                                                    )}
                                                    onClick={this._addCensusManually}
                                                >
                                                    <InputTypeIcon
                                                        className={css(
                                                            styles.censusIcon,
                                                            styles.inputTypeIcon,
                                                        )}
                                                    />
                                                    <div className={css(styles.censusButtonText)}>
                                                        {strings.addCensusManually}
                                                    </div>
                                                </div>
                                                <div className={css(styles.censusOptionItemHeader)}>
                                                    <div
                                                        className={css(
                                                            styles.censusOptionItemHeaderText,
                                                        )}
                                                    >
                                                        {" "}
                                                    </div>
                                                </div>
                                                <div
                                                    className={css(
                                                        styles.censusButton,
                                                        styles.createCensusButton2,
                                                    )}
                                                    onClick={this._quickAddCensus}
                                                >
                                                    <InputTypeIcon
                                                        className={css(
                                                            styles.censusIcon,
                                                            styles.inputTypeIcon,
                                                        )}
                                                    />
                                                    <div className={css(styles.censusButtonText)}>
                                                        {"Quick Add Census With " +
                                                            quote.totalNumberEligibleEmployees +
                                                            " Member" +
                                                            (quote.totalNumberEligibleEmployees ===
                                                            1
                                                                ? ""
                                                                : "s")}
                                                    </div>
                                                </div>
                                            </div>
                                        </Column>
                                    </React.Fragment>
                                )}
                            </Row>
                        </Container>
                        <div className={css(styles.censusButtonContainer)}>
                            {this.state.censusUpload && (
                                <ActionButton
                                    aStyles={styles.cancelButton}
                                    disabled={this.state.loading}
                                    label={strings.backButton}
                                    invertColor={true}
                                    type="button"
                                    onClick={this._cancelClicked}
                                />
                            )}
                            {this.state.censusUpload !== null && (
                                <ActionButton
                                    aStyles={styles.submitCensusButton}
                                    disabled={this.state.loading}
                                    label={strings.submitButton}
                                    type="button"
                                    onClick={this._submitCensus}
                                    isLoading={this.props.isSaving}
                                />
                            )}
                        </div>
                    </div>
                )}
                {/*Manual Census*/}
                {!isSubmittingCensus && isManualCensus && (
                    <div className={css(styles.manualCensusContainer)}>
                        <Container>
                            <Row>
                                <Column large={12}>
                                    <div className={css(styles.confirmCensusHeader)}>
                                        <div className={css(styles.confirmCensusButtonHolder)}>
                                            <ActionButton
                                                aStyles={styles.currentPlansButton}
                                                disabled={this.state.loading}
                                                label={strings.currentPlansModalButton}
                                                onClick={this._showCurrentPlansModal}
                                                type="button"
                                                isSecondaryButton={true}
                                            />
                                            <ActionButton
                                                aStyles={styles.cancelButton}
                                                disabled={this.state.loading}
                                                label={strings.cancelButton}
                                                invertColor={true}
                                                type="button"
                                                onClick={this._cancelClicked}
                                            />
                                            <ActionButton
                                                aStyles={styles.submitCensusButton}
                                                disabled={this.state.loading}
                                                label={strings.confirmCensusButton}
                                                onClick={this._confirmClicked}
                                                type="button"
                                            />
                                        </div>
                                        <div className={css(styles.confirmCensusHeaderText)}>
                                            {strings.censusDetails}
                                        </div>
                                    </div>
                                    {quote.censusUploadErrors && (
                                        <div className={css(styles.censusUploadErrors)}>
                                            <div className={css(styles.censusUploadHeader)}>
                                                <AlertIcon
                                                    className="census-upload-alert-icon"
                                                    style={{
                                                        marginRight: 8,
                                                        verticalAlign: "middle",
                                                    }}
                                                />
                                                {strings.censusUploadErrors}
                                            </div>
                                            {quote.censusUploadErrors.split("|").map((err, idx) => (
                                                <span key={idx}>
                                                    {err}
                                                    <br />
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                    <table className={css(styles.censusTable)}>
                                        <thead>
                                            <tr>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderCol2pct,
                                                    )}
                                                >
                                                    No.
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderCol2pct,
                                                    )}
                                                >
                                                    Rel
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderCol8pctWith100px,
                                                    )}
                                                >
                                                    First Name
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderCol8pctWith100px,
                                                    )}
                                                >
                                                    Last Name
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderColDOB,
                                                    )}
                                                >
                                                    DOB
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderCol3pct,
                                                    )}
                                                >
                                                    Gen
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderCol3pct,
                                                    )}
                                                >
                                                    Med
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderCol3pct,
                                                    )}
                                                >
                                                    Den
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderCol3pct,
                                                    )}
                                                >
                                                    Vis
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderCol3pct,
                                                    )}
                                                >
                                                    Life
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderColZip,
                                                    )}
                                                >
                                                    H ZIP
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderColZip,
                                                    )}
                                                >
                                                    W ZIP
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderColTitle,
                                                    )}
                                                >
                                                    Title
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderColSalary,
                                                    )}
                                                >
                                                    Salary
                                                </th>
                                                {/* DOH column — commented out; restore if needed
                                                <th
                                                    className={css(styles.censusTableHeader)}
                                                    style={{
                                                        width: "9%",
                                                        minWidth: "115px",
                                                        maxWidth: "125px",
                                                    }}
                                                >
                                                    DOH
                                                </th>
                                                */}
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderColEmail,
                                                    )}
                                                >
                                                    Email
                                                </th>
                                                {/* < !-- Redo sizes -- >*/}
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderColPlan,
                                                    )}
                                                >
                                                    Current Plan
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusHeaderColDOB,
                                                    )}
                                                >
                                                    EE Eff Date
                                                </th>
                                                {/* 32 is CA (California) - only show PPO/HMO columns for California */}
                                                {this.props.areaId === 32 && (
                                                    <th
                                                        className={css(
                                                            styles.censusTableHeader,
                                                            styles.censusPlanFlagCell,
                                                            styles.planFlagHeader,
                                                        )}
                                                    >
                                                        <div
                                                            className={css(styles.planHeaderLabel)}
                                                        >
                                                            PPO
                                                        </div>
                                                        <div
                                                            className={css(styles.planHeaderLinks)}
                                                        >
                                                            <a
                                                                href="#"
                                                                className={css(
                                                                    styles.planHeaderLink,
                                                                )}
                                                                onClick={this._toggleAllPlanCheckboxes(
                                                                    "PPO",
                                                                    true,
                                                                )}
                                                            >
                                                                All
                                                            </a>
                                                            {" | "}
                                                            <a
                                                                href="#"
                                                                className={css(
                                                                    styles.planHeaderLink,
                                                                )}
                                                                onClick={this._toggleAllPlanCheckboxes(
                                                                    "PPO",
                                                                    false,
                                                                )}
                                                            >
                                                                None
                                                            </a>
                                                        </div>
                                                    </th>
                                                )}
                                                {/* 32 is CA (California) - only show PPO/HMO columns for California */}
                                                {this.props.areaId === 32 && (
                                                    <th
                                                        className={css(
                                                            styles.censusTableHeader,
                                                            styles.censusPlanFlagCell,
                                                            styles.planFlagHeader,
                                                        )}
                                                    >
                                                        <div
                                                            className={css(styles.planHeaderLabel)}
                                                        >
                                                            HMO
                                                        </div>
                                                        <div
                                                            className={css(styles.planHeaderLinks)}
                                                        >
                                                            <a
                                                                href="#"
                                                                className={css(
                                                                    styles.planHeaderLink,
                                                                )}
                                                                onClick={this._toggleAllPlanCheckboxes(
                                                                    "HMO",
                                                                    true,
                                                                )}
                                                            >
                                                                All
                                                            </a>
                                                            {" | "}
                                                            <a
                                                                href="#"
                                                                className={css(
                                                                    styles.planHeaderLink,
                                                                )}
                                                                onClick={this._toggleAllPlanCheckboxes(
                                                                    "HMO",
                                                                    false,
                                                                )}
                                                            >
                                                                None
                                                            </a>
                                                        </div>
                                                    </th>
                                                )}
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusPlanFlagCell,
                                                        styles.planFlagHeader,
                                                    )}
                                                >
                                                    <div className={css(styles.planHeaderLabel)}>
                                                        COBRA
                                                    </div>
                                                    <div className={css(styles.planHeaderLinks)}>
                                                        <a
                                                            href="#"
                                                            className={css(styles.planHeaderLink)}
                                                            onClick={this._toggleAllPlanCheckboxes(
                                                                "COBRA",
                                                                true,
                                                            )}
                                                        >
                                                            All
                                                        </a>
                                                        {" | "}
                                                        <a
                                                            href="#"
                                                            className={css(styles.planHeaderLink)}
                                                            onClick={this._toggleAllPlanCheckboxes(
                                                                "COBRA",
                                                                false,
                                                            )}
                                                        >
                                                            None
                                                        </a>
                                                    </div>
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusPlanFlagCell,
                                                        styles.planFlagHeader,
                                                    )}
                                                >
                                                    <div className={css(styles.planHeaderLabel)}>
                                                        TOB
                                                    </div>
                                                    <div className={css(styles.planHeaderLinks)}>
                                                        <a
                                                            href="#"
                                                            className={css(styles.planHeaderLink)}
                                                            onClick={this._toggleAllPlanCheckboxes(
                                                                "TOB",
                                                                true,
                                                            )}
                                                        >
                                                            All
                                                        </a>
                                                        {" | "}
                                                        <a
                                                            href="#"
                                                            className={css(styles.planHeaderLink)}
                                                            onClick={this._toggleAllPlanCheckboxes(
                                                                "TOB",
                                                                false,
                                                            )}
                                                        >
                                                            None
                                                        </a>
                                                    </div>
                                                </th>
                                                <th
                                                    className={css(
                                                        styles.censusTableHeader,
                                                        styles.censusActionCell,
                                                    )}
                                                >
                                                    {" "}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {census.map((cen, index) => {
                                                const memberTabBase = censusTabBases[index] || 0;
                                                return (
                                                    <React.Fragment key={index}>
                                                        <tr>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.greenBar,
                                                                )}
                                                            >
                                                                {cen.sequenceNumber}
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusPlanFlagCell,
                                                                )}
                                                            >
                                                                {cen.relationship}
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusDobCell,
                                                                )}
                                                            >
                                                                <TextInput
                                                                    tabIndex={memberTabBase + 1}
                                                                    value={cen.firstName}
                                                                    placeholder="- First -"
                                                                    onChange={e =>
                                                                        this._setFirstName(
                                                                            e,
                                                                            cen,
                                                                            null,
                                                                        )
                                                                    }
                                                                    hideLabel={true}
                                                                    size="small"
                                                                    validationMessage={
                                                                        !cen.firstName ? "*" : ""
                                                                    }
                                                                />
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusTitleCell,
                                                                )}
                                                            >
                                                                <TextInput
                                                                    tabIndex={memberTabBase + 2}
                                                                    value={cen.lastName}
                                                                    placeholder="- Last -"
                                                                    onChange={e =>
                                                                        this._setLastName(
                                                                            e,
                                                                            cen,
                                                                            null,
                                                                        )
                                                                    }
                                                                    hideLabel={true}
                                                                    size="small"
                                                                    validationMessage={
                                                                        !cen.lastName ? "*" : ""
                                                                    }
                                                                />
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusDobCell,
                                                                )}
                                                            >
                                                                <TextInput
                                                                    tabIndex={memberTabBase + 3}
                                                                    value={
                                                                        cen.birthDate &&
                                                                        cen.birthDate.length >= 10
                                                                            ? format(
                                                                                  cen.birthDate,
                                                                                  "MM/DD/YYYY",
                                                                              )
                                                                            : cen.birthDate
                                                                            ? cen.birthDate
                                                                            : ""
                                                                    }
                                                                    placeholder="- MM/DD/YYYY -"
                                                                    onChange={e =>
                                                                        this._setDOB(e, cen, null)
                                                                    }
                                                                    disableSmallWidthBounds={true}
                                                                    hideLabel={true}
                                                                    size="small"
                                                                    validationMessage={
                                                                        !cen.birthDate ||
                                                                        cen.birthDate.length < 10
                                                                            ? "*"
                                                                            : ""
                                                                    }
                                                                />
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusPlanFlagCell,
                                                                )}
                                                            >
                                                                <SmallDropdown
                                                                    tabIndex={memberTabBase + 4}
                                                                    name={inputNames.gender}
                                                                    placeholder="- M/F -"
                                                                    options={this.state.gender.map(
                                                                        o => ({
                                                                            label: o.name,
                                                                            value: o.id,
                                                                        }),
                                                                    )}
                                                                    onChange={e =>
                                                                        this._setGender(
                                                                            e,
                                                                            cen,
                                                                            null,
                                                                        )
                                                                    }
                                                                    value={cen.gender}
                                                                    validationMessage={
                                                                        !cen.gender ? "*" : ""
                                                                    }
                                                                />
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusPlanFlagCell,
                                                                )}
                                                            >
                                                                <SmallDropdown
                                                                    tabIndex={memberTabBase + 5}
                                                                    name={
                                                                        inputNames.medicalCoverage
                                                                    }
                                                                    placeholder="- Med -"
                                                                    options={this.state.coverage.map(
                                                                        o => ({
                                                                            label: o.name,
                                                                            value: o.id,
                                                                        }),
                                                                    )}
                                                                    onChange={e =>
                                                                        this._setMedicalCoverage(
                                                                            e,
                                                                            cen,
                                                                            null,
                                                                        )
                                                                    }
                                                                    value={
                                                                        cen.medicalCoverageId
                                                                            ? cen.medicalCoverageId.toString()
                                                                            : "1"
                                                                    }
                                                                />
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusPlanFlagCell,
                                                                )}
                                                            >
                                                                <SmallDropdown
                                                                    tabIndex={memberTabBase + 6}
                                                                    name={inputNames.dentalCoverage}
                                                                    placeholder="- Den -"
                                                                    options={this.state.coverage.map(
                                                                        o => ({
                                                                            label: o.name,
                                                                            value: o.id,
                                                                        }),
                                                                    )}
                                                                    onChange={e =>
                                                                        this._setDentalCoverage(
                                                                            e,
                                                                            cen,
                                                                            null,
                                                                        )
                                                                    }
                                                                    value={
                                                                        cen.dentalCoverageId
                                                                            ? cen.dentalCoverageId.toString()
                                                                            : "1"
                                                                    }
                                                                />
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusPlanFlagCell,
                                                                )}
                                                            >
                                                                <SmallDropdown
                                                                    tabIndex={memberTabBase + 7}
                                                                    name={inputNames.visionCoverage}
                                                                    placeholder="- Vis -"
                                                                    options={this.state.coverage.map(
                                                                        o => ({
                                                                            label: o.name,
                                                                            value: o.id,
                                                                        }),
                                                                    )}
                                                                    onChange={e =>
                                                                        this._setVisionCoverage(
                                                                            e,
                                                                            cen,
                                                                            null,
                                                                        )
                                                                    }
                                                                    value={
                                                                        cen.visionCoverageId
                                                                            ? cen.visionCoverageId.toString()
                                                                            : "1"
                                                                    }
                                                                />
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusPlanFlagCell,
                                                                )}
                                                            >
                                                                <SmallDropdown
                                                                    tabIndex={memberTabBase + 8}
                                                                    name={inputNames.lifeCoverage}
                                                                    placeholder="- Lif -"
                                                                    options={this.state.coverage2.map(
                                                                        o => ({
                                                                            label: o.name,
                                                                            value: o.id,
                                                                        }),
                                                                    )}
                                                                    onChange={e =>
                                                                        this._setLifeCoverage(
                                                                            e,
                                                                            cen,
                                                                            null,
                                                                        )
                                                                    }
                                                                    value={
                                                                        cen.lifeCoverageId
                                                                            ? cen.lifeCoverageId.toString()
                                                                            : "1"
                                                                    }
                                                                />
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusZipCell,
                                                                )}
                                                            >
                                                                <TextInput
                                                                    tabIndex={memberTabBase + 9}
                                                                    value={
                                                                        cen.homePostalCode
                                                                            ? cen.homePostalCode
                                                                            : ""
                                                                    }
                                                                    placeholder="- 00000 -"
                                                                    onChange={e =>
                                                                        this._setHZip(e, cen, null)
                                                                    }
                                                                    disableSmallWidthBounds={true}
                                                                    hideLabel={true}
                                                                    size="small"
                                                                    validationMessage={
                                                                        !cen.homePostalCode ||
                                                                        cen.homePostalCode.length <
                                                                            5
                                                                            ? "*"
                                                                            : ""
                                                                    }
                                                                />
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusZipCell,
                                                                )}
                                                            >
                                                                <TextInput
                                                                    tabIndex={memberTabBase + 10}
                                                                    value={
                                                                        cen.workPostalCode
                                                                            ? cen.workPostalCode
                                                                            : ""
                                                                    }
                                                                    placeholder="- 00000 -"
                                                                    onChange={e =>
                                                                        this._setWZip(e, cen)
                                                                    }
                                                                    disableSmallWidthBounds={true}
                                                                    hideLabel={true}
                                                                    size="small"
                                                                />
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                )}
                                                            >
                                                                <TextInput
                                                                    tabIndex={memberTabBase + 11}
                                                                    value={
                                                                        cen.occupation
                                                                            ? cen.occupation
                                                                            : ""
                                                                    }
                                                                    placeholder="- Title -"
                                                                    onChange={e =>
                                                                        this._setOccupation(e, cen)
                                                                    }
                                                                    disableSmallWidthBounds={true}
                                                                    hideLabel={true}
                                                                    size="small"
                                                                />
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusSalaryCell,
                                                                )}
                                                            >
                                                                <TextInput
                                                                    tabIndex={memberTabBase + 12}
                                                                    value={
                                                                        cen.salary ? cen.salary : ""
                                                                    }
                                                                    placeholder="- Salary -"
                                                                    onChange={e =>
                                                                        this._setSalary(e, cen)
                                                                    }
                                                                    disableSmallWidthBounds={true}
                                                                    hideLabel={true}
                                                                    size="small"
                                                                />
                                                            </td>
                                                            {/* DOH column — commented out; restore if needed
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                )}
                                                            >
                                                                <TextInput
                                                                    tabIndex={index * 100 + 13}
                                                                    value={
                                                                        cen.hireDate &&
                                                                        cen.hireDate.length >= 10
                                                                            ? format(
                                                                                  cen.hireDate,
                                                                                  "MM/DD/YYYY",
                                                                              )
                                                                            : cen.hireDate
                                                                            ? cen.hireDate
                                                                            : ""
                                                                    }
                                                                    placeholder="- MM/DD/YYYY -"
                                                                    onChange={e =>
                                                                        this._setDOH(e, cen)
                                                                    }
                                                                    hideLabel={true}
                                                                    size="small"
                                                                />
                                                            </td>
                                                            */}
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                )}
                                                            >
                                                                <TextInput
                                                                    tabIndex={memberTabBase + 14}
                                                                    value={
                                                                        cen.email ? cen.email : ""
                                                                    }
                                                                    placeholder="- Email -"
                                                                    onChange={e =>
                                                                        this._setEmail(e, cen)
                                                                    }
                                                                    hideLabel={true}
                                                                    size="small"
                                                                />
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                )}
                                                            >
                                                                {/*
						name={inputNames.billingContactInvoiceTimingId}
                        options={this.state.billingInvoiceTimings.map(item => ({
                            label: item.name,
                            value: item.id,
                        }))}
                        onChange={this._handleDropdownChanged}
                        placeholder="Select frequency"
                        validationMessage={this.state.errors[inputNames.billingContactInvoiceTimingId]}
                        value={this.state.inputs[inputNames.billingContactInvoiceTimingId]}                        
                        disabled={!isEditable}
                                                                */}
                                                                {this.state.mappedPlanOptions &&
                                                                this.state.mappedPlanOptions
                                                                    .length > 0 ? (
                                                                    <div
                                                                        className={css(
                                                                            styles.currentPlanCellWrap,
                                                                        )}
                                                                    >
                                                                        {/* Hidden alias dropdown — keeps currentMedicalPlanName in sync */}
                                                                        <select
                                                                            style={{
                                                                                display: "none",
                                                                            }}
                                                                            value={
                                                                                cen.currentMedicalPlanName
                                                                            }
                                                                            readOnly
                                                                        />

                                                                        {/* Visible mapped plans dropdown */}
                                                                        <SmallDropdown
                                                                            tabIndex={
                                                                                memberTabBase + 15
                                                                            }
                                                                            name={
                                                                                inputNames.currentMedicalPlanName
                                                                            }
                                                                            placeholder="choose current plan"
                                                                            options={this.state.mappedPlanOptions.map(
                                                                                opt => ({
                                                                                    label:
                                                                                        opt.label,
                                                                                    value:
                                                                                        opt.value,
                                                                                }),
                                                                            )}
                                                                            onChange={selected =>
                                                                                this._handleMappedPlanSelect(
                                                                                    selected,
                                                                                    cen,
                                                                                )
                                                                            }
                                                                            value={(() => {
                                                                                let match = cen.currentMedicalPlanId
                                                                                    ? this.state.mappedPlanOptions.find(
                                                                                          opt =>
                                                                                              String(
                                                                                                  opt.value,
                                                                                              ) ===
                                                                                              String(
                                                                                                  cen.currentMedicalPlanId,
                                                                                              ),
                                                                                      )
                                                                                    : null;
                                                                                if (!match) {
                                                                                    match = this.state.mappedPlanOptions.find(
                                                                                        opt =>
                                                                                            opt.alias ===
                                                                                            cen.currentMedicalPlanName,
                                                                                    );
                                                                                }
                                                                                return match
                                                                                    ? match.value
                                                                                    : "";
                                                                            })()}
                                                                            validationMessage={
                                                                                !cen.currentMedicalPlanName
                                                                                    ? "*"
                                                                                    : ""
                                                                            }
                                                                        />
                                                                        <Hover
                                                                            onHover={
                                                                                <div>
                                                                                    {getCurrentPlanHoverText(
                                                                                        cen,
                                                                                    )}
                                                                                </div>
                                                                            }
                                                                        >
                                                                            <div>?</div>
                                                                        </Hover>
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        className={css(
                                                                            styles.currentPlanCellWrap,
                                                                        )}
                                                                    >
                                                                        <SmallDropdown
                                                                            tabIndex={
                                                                                memberTabBase + 15
                                                                            }
                                                                            name={
                                                                                inputNames.currentMedicalPlanName
                                                                            }
                                                                            placeholder="choose current plan"
                                                                            options={(
                                                                                this.state
                                                                                    .currentPlans || []
                                                                            ).map(
                                                                                (
                                                                                    plan,
                                                                                    planIndex,
                                                                                ) => ({
                                                                                    label:
                                                                                        typeof plan ===
                                                                                        "string"
                                                                                            ? plan
                                                                                            : plan.alias ||
                                                                                              plan.name ||
                                                                                              `Plan ${planIndex +
                                                                                                  1}`,
                                                                                    value:
                                                                                        typeof plan ===
                                                                                        "string"
                                                                                            ? plan
                                                                                            : plan.alias ||
                                                                                              plan.name ||
                                                                                              `Plan ${planIndex +
                                                                                                  1}`,
                                                                                }),
                                                                            )}
                                                                            onChange={e =>
                                                                                this._setcurrentMedicalPlanName(
                                                                                    e,
                                                                                    cen,
                                                                                    null,
                                                                                )
                                                                            }
                                                                            value={
                                                                                cen.currentMedicalPlanName
                                                                            }
                                                                            validationMessage={
                                                                                !cen.currentMedicalPlanName
                                                                                    ? "*"
                                                                                    : ""
                                                                            }
                                                                        />
                                                                        <Hover
                                                                            onHover={
                                                                                <div>
                                                                                    {getCurrentPlanHoverText(
                                                                                        cen,
                                                                                    )}
                                                                                </div>
                                                                            }
                                                                        >
                                                                            <div>?</div>
                                                                        </Hover>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusDobCell,
                                                                )}
                                                            >
                                                                <TextInput
                                                                    tabIndex={memberTabBase + 16}
                                                                    value={
                                                                        cen.enrollmentDate &&
                                                                        cen.enrollmentDate.length >=
                                                                            10
                                                                            ? format(
                                                                                  cen.enrollmentDate,
                                                                                  "MM/DD/YYYY",
                                                                              )
                                                                            : cen.enrollmentDate
                                                                            ? cen.enrollmentDate
                                                                            : ""
                                                                    }
                                                                    placeholder="- MM/DD/YYYY -"
                                                                    onChange={e =>
                                                                        this._setEnrollmentDate(
                                                                            e,
                                                                            cen,
                                                                        )
                                                                    }
                                                                    disableSmallWidthBounds={true}
                                                                    hideLabel={true}
                                                                    size="small"
                                                                />
                                                            </td>
                                                            {/* 32 is CA (California) - only show PPO/HMO columns for California */}
                                                            {this.props.areaId === 32 && (
                                                                <td
                                                                    className={css(
                                                                        styles.censusTableCell,
                                                                        styles.censusPlanFlagCell,
                                                                    )}
                                                                >
                                                                    <label
                                                                        className={css(
                                                                            styles.checkLabel,
                                                                        )}
                                                                    >
                                                                        <Checkbox
                                                                            aStyles={styles.check}
                                                                            checked={!!cen.isPPO}
                                                                            name={inputNames.isPPO}
                                                                            onChange={e =>
                                                                                this._handleInputChange(
                                                                                    e,
                                                                                    cen,
                                                                                )
                                                                            }
                                                                        />
                                                                        {/*strings.isPPO*/}
                                                                    </label>
                                                                    {/*
                                                                
                                                                        disabled={
                                                                            !(
                                                                                me.isSysAdmin ||
                                                                                me.isOfficeAdmin
                                                                            ) || broker.deleted
                                                                        }



                                                                <SmallDropdown
                                                                    tabIndex={index * 100 + 16}
                                                                    name={inputNames.onCobra}
                                                                    placeholder="- Y/N -"
                                                                    options={this.state.yesNo.map(
                                                                        o => ({
                                                                            label: o.name,
                                                                            value: o.id,
                                                                        }),
                                                                    )}
                                                                    onChange={e =>
                                                                        this._setCOB(e, cen)
                                                                    }
                                                                    value={cen.onCobra ? "1" : "0"}
                                                                /> 
                                                                */}
                                                                </td>
                                                            )}
                                                            {/* 32 is CA (California) - only show PPO/HMO columns for California */}
                                                            {this.props.areaId === 32 && (
                                                                <td
                                                                    className={css(
                                                                        styles.censusTableCell,
                                                                        styles.censusPlanFlagCell,
                                                                    )}
                                                                >
                                                                    <label
                                                                        className={css(
                                                                            styles.checkLabel,
                                                                        )}
                                                                    >
                                                                        <Checkbox
                                                                            aStyles={styles.check}
                                                                            checked={!!cen.isHMO}
                                                                            name={inputNames.isHMO}
                                                                            onChange={e =>
                                                                                this._handleInputChange(
                                                                                    e,
                                                                                    cen,
                                                                                )
                                                                            }
                                                                        />
                                                                        {/*strings.isHMO*/}
                                                                    </label>
                                                                    {/*<SmallDropdown
                                                                    tabIndex={index * 100 + 17}
                                                                    name={inputNames.isTobacco}
                                                                    placeholder="- Y/N -"
                                                                    options={this.state.yesNo.map(
                                                                        o => ({
                                                                            label: o.name,
                                                                            value: o.id,
                                                                        }),
                                                                    )}
                                                                    onChange={e =>
                                                                        this._setTobacco(
                                                                            e,
                                                                            cen,
                                                                            null,
                                                                        )
                                                                    }
                                                                    value={
                                                                        cen.isTobacco ? "1" : "0"
                                                                    }
                                                                />*/}
                                                                </td>
                                                            )}
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusPlanFlagCell,
                                                                )}
                                                            >
                                                                <label
                                                                    className={css(
                                                                        styles.checkLabel,
                                                                    )}
                                                                >
                                                                    <Checkbox
                                                                        aStyles={styles.check}
                                                                        checked={!!cen.onCobra}
                                                                        name={inputNames.onCobra}
                                                                        onChange={e =>
                                                                            this._handleInputChange(
                                                                                e,
                                                                                cen,
                                                                            )
                                                                        }
                                                                    />
                                                                    {/*strings.onCobra*/}
                                                                </label>
                                                                {/*
                                                                <SmallDropdown
                                                                    tabIndex={index * 100 + 18}
                                                                    name={inputNames.onCobra}
                                                                    placeholder="- Y/N -"
                                                                    options={this.state.yesNo.map(
                                                                        o => ({
                                                                            label: o.name,
                                                                            value: o.id,
                                                                        }),
                                                                    )}
                                                                    onChange={e =>
                                                                        this._setCOB(e, cen)
                                                                    }
                                                                    value={cen.onCobra ? "1" : "0"}
                                                                />
                                                                */}
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusPlanFlagCell,
                                                                )}
                                                            >
                                                                <label
                                                                    className={css(
                                                                        styles.checkLabel,
                                                                    )}
                                                                >
                                                                    <Checkbox
                                                                        aStyles={styles.check}
                                                                        checked={!!cen.isTobacco}
                                                                        name={inputNames.isTobacco}
                                                                        onChange={e =>
                                                                            this._handleInputChange(
                                                                                e,
                                                                                cen,
                                                                            )
                                                                        }
                                                                    />
                                                                    {/*strings.isTobacco*/}
                                                                </label>
                                                                {/*
                                                                <SmallDropdown
                                                                    tabIndex={index * 100 + 19}
                                                                    name={inputNames.isTobacco}
                                                                    placeholder="- Y/N -"
                                                                    options={this.state.yesNo.map(
                                                                        o => ({
                                                                            label: o.name,
                                                                            value: o.id,
                                                                        }),
                                                                    )}
                                                                    onChange={e =>
                                                                        this._setTobacco(
                                                                            e,
                                                                            cen,
                                                                            null,
                                                                        )
                                                                    }
                                                                    value={
                                                                        cen.isTobacco ? "1" : "0"
                                                                    }
                                                                />
                                                                */}
                                                            </td>
                                                            <td
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                )}
                                                            >
                                                                <CancelIcon
                                                                    className={css(
                                                                        styles.clearCensusButton,
                                                                    )}
                                                                    onClick={() =>
                                                                        this._removeCensusMember(
                                                                            cen,
                                                                        )
                                                                    }
                                                                />
                                                            </td>
                                                        </tr>
                                                        {cen.dependents.map((dep, index2) => {
                                                            const dependentTabBase =
                                                                memberTabBase +
                                                                MEMBER_TAB_FIELD_COUNT +
                                                                index2 * DEPENDENT_TAB_FIELD_COUNT;

                                                            return (
                                                                <tr
                                                                    key={index * 100 + index2}
                                                                    className="sub"
                                                                >
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                            styles.blueBar,
                                                                        )}
                                                                    >
                                                                        {dep.sequenceNumber}
                                                                    </td>
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                        )}
                                                                    >
                                                                        <SmallDropdown
                                                                            tabIndex={
                                                                                dependentTabBase + 1
                                                                            }
                                                                            name={
                                                                                inputNames.relationship
                                                                            }
                                                                            placeholder="- SP/C -"
                                                                            options={this.state.relationship.map(
                                                                                o => ({
                                                                                    label: o.name,
                                                                                    value: o.name,
                                                                                }),
                                                                            )}
                                                                            onChange={e =>
                                                                                this._setRelationship(
                                                                                    e,
                                                                                    cen,
                                                                                    dep,
                                                                                )
                                                                            }
                                                                            value={
                                                                                dep.dependentType ===
                                                                                "Spouse"
                                                                                    ? "SP"
                                                                                    : "C"
                                                                            }
                                                                            validationMessage={
                                                                                !dep.relationship
                                                                                    ? "*"
                                                                                    : ""
                                                                            }
                                                                        />
                                                                    </td>
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                            styles.censusDobCell,
                                                                        )}
                                                                    >
                                                                        <TextInput
                                                                            tabIndex={
                                                                                dependentTabBase + 2
                                                                            }
                                                                            value={dep.firstName}
                                                                            placeholder="- First -"
                                                                            onChange={e =>
                                                                                this._setFirstName(
                                                                                    e,
                                                                                    cen,
                                                                                    dep,
                                                                                )
                                                                            }
                                                                            hideLabel={true}
                                                                            size="small"
                                                                            validationMessage={
                                                                                !dep.firstName
                                                                                    ? "*"
                                                                                    : ""
                                                                            }
                                                                        />
                                                                    </td>
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                        )}
                                                                    >
                                                                        <TextInput
                                                                            tabIndex={
                                                                                dependentTabBase + 3
                                                                            }
                                                                            value={dep.lastName}
                                                                            placeholder="- Last -"
                                                                            onChange={e =>
                                                                                this._setLastName(
                                                                                    e,
                                                                                    cen,
                                                                                    dep,
                                                                                )
                                                                            }
                                                                            hideLabel={true}
                                                                            size="small"
                                                                            validationMessage={
                                                                                !dep.lastName
                                                                                    ? "*"
                                                                                    : ""
                                                                            }
                                                                        />
                                                                    </td>
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                        )}
                                                                    >
                                                                        <TextInput
                                                                            tabIndex={
                                                                                dependentTabBase + 4
                                                                            }
                                                                            value={
                                                                                dep.birthDate &&
                                                                                dep.birthDate
                                                                                    .length >= 10
                                                                                    ? format(
                                                                                          dep.birthDate,
                                                                                          "MM/DD/YYYY",
                                                                                      )
                                                                                    : dep.birthDate
                                                                                    ? dep.birthDate
                                                                                    : ""
                                                                            }
                                                                            placeholder="- MM/DD/YYYY -"
                                                                            onChange={e =>
                                                                                this._setDOB(
                                                                                    e,
                                                                                    cen,
                                                                                    dep,
                                                                                )
                                                                            }
                                                                            disableSmallWidthBounds={
                                                                                true
                                                                            }
                                                                            data-type="date"
                                                                            hideLabel={true}
                                                                            size="small"
                                                                            validationMessage={
                                                                                !dep.birthDate ||
                                                                                dep.birthDate
                                                                                    .length < 10
                                                                                    ? "*"
                                                                                    : ""
                                                                            }
                                                                        />
                                                                    </td>
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                        )}
                                                                    >
                                                                        <SmallDropdown
                                                                            tabIndex={
                                                                                dependentTabBase + 5
                                                                            }
                                                                            name={inputNames.gender}
                                                                            placeholder="- M/F -"
                                                                            options={this.state.gender.map(
                                                                                o => ({
                                                                                    label: o.name,
                                                                                    value: o.id,
                                                                                }),
                                                                            )}
                                                                            onChange={e =>
                                                                                this._setGender(
                                                                                    e,
                                                                                    cen,
                                                                                    dep,
                                                                                )
                                                                            }
                                                                            value={dep.gender}
                                                                            validationMessage={
                                                                                !dep.gender
                                                                                    ? "*"
                                                                                    : ""
                                                                            }
                                                                        />
                                                                    </td>
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                            styles.censusPlanFlagCell,
                                                                        )}
                                                                    >
                                                                        {" "}
                                                                    </td>
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                            styles.censusPlanFlagCell,
                                                                        )}
                                                                    >
                                                                        {" "}
                                                                    </td>
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                            styles.censusPlanFlagCell,
                                                                        )}
                                                                    >
                                                                        {" "}
                                                                    </td>
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                            styles.censusPlanFlagCell,
                                                                        )}
                                                                    >
                                                                        {" "}
                                                                    </td>
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                            styles.censusZipCell,
                                                                        )}
                                                                    >
                                                                        {ENABLE_DEPENDENT_ZIP_EDIT ? (
                                                                            <TextInput
                                                                                tabIndex={
                                                                                    dependentTabBase +
                                                                                    6
                                                                                }
                                                                                value={
                                                                                    dep.homePostalCode
                                                                                        ? dep.homePostalCode
                                                                                        : ""
                                                                                }
                                                                                placeholder="- 00000 -"
                                                                                onChange={e =>
                                                                                    this._setHZip(
                                                                                        e,
                                                                                        cen,
                                                                                        dep,
                                                                                    )
                                                                                }
                                                                                disableSmallWidthBounds={
                                                                                    true
                                                                                }
                                                                                hideLabel={true}
                                                                                size="small"
                                                                                validationMessage={
                                                                                    !dep.homePostalCode ||
                                                                                    dep
                                                                                        .homePostalCode
                                                                                        .length < 5
                                                                                        ? "*"
                                                                                        : ""
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            <span>
                                                                                {cen.homePostalCode ||
                                                                                    ""}
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                    {dep.dependentType !==
                                                                    "Spouse" ? (
                                                                        <td
                                                                            colSpan={3}
                                                                            className={css(
                                                                                styles.censusTableCell,
                                                                            )}
                                                                        >
                                                                            <div
                                                                                className={css(
                                                                                    styles.dependentStatusContainer,
                                                                                )}
                                                                            >
                                                                                <span
                                                                                    className={css(
                                                                                        styles.dependentStatusLabel,
                                                                                    )}
                                                                                >
                                                                                    Dependent Status
                                                                                </span>
                                                                                <SmallDropdown
                                                                                    tabIndex={
                                                                                        dependentTabBase +
                                                                                        (ENABLE_DEPENDENT_ZIP_EDIT
                                                                                            ? 7
                                                                                            : 6)
                                                                                    }
                                                                                    name={
                                                                                        inputNames.childDependentStatus
                                                                                    }
                                                                                    placeholder="- Status -"
                                                                                    options={[
                                                                                        {
                                                                                            label:
                                                                                                "Child",
                                                                                            value:
                                                                                                "Child",
                                                                                        },
                                                                                        {
                                                                                            label:
                                                                                                "Student",
                                                                                            value:
                                                                                                "Student",
                                                                                        },
                                                                                        {
                                                                                            label:
                                                                                                "Disabled",
                                                                                            value:
                                                                                                "Disabled",
                                                                                        },
                                                                                    ]}
                                                                                    onChange={e =>
                                                                                        this._setChildDependentStatus(
                                                                                            e,
                                                                                            cen,
                                                                                            dep,
                                                                                        )
                                                                                    }
                                                                                    value={
                                                                                        dep.childDependentStatus ||
                                                                                        "Child"
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </td>
                                                                    ) : (
                                                                        <>
                                                                            <td
                                                                                className={css(
                                                                                    styles.censusTableCell,
                                                                                    styles.censusZipCell,
                                                                                )}
                                                                            >
                                                                                {" "}
                                                                            </td>
                                                                            <td
                                                                                className={css(
                                                                                    styles.censusTableCell,
                                                                                )}
                                                                            >
                                                                                {" "}
                                                                            </td>
                                                                            <td
                                                                                className={css(
                                                                                    styles.censusTableCell,
                                                                                )}
                                                                            >
                                                                                {" "}
                                                                            </td>
                                                                            {/* DOH column — commented out; restore if needed
                                                                        <td
                                                                            className={css(
                                                                                styles.censusTableCell,
                                                                            )}
                                                                        >
                                                                            {" "}
                                                                        </td>
                                                                        */}
                                                                        </>
                                                                    )}
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                        )}
                                                                    >
                                                                        {" "}
                                                                    </td>
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                        )}
                                                                    >
                                                                        {" "}
                                                                    </td>
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                        )}
                                                                    >
                                                                        {" "}
                                                                    </td>
                                                                    {this.props.areaId === 32 && (
                                                                        <td
                                                                            className={css(
                                                                                styles.censusTableCell,
                                                                                styles.censusPlanFlagCell,
                                                                            )}
                                                                        >
                                                                            {" "}
                                                                        </td>
                                                                    )}
                                                                    {this.props.areaId === 32 && (
                                                                        <td
                                                                            className={css(
                                                                                styles.censusTableCell,
                                                                                styles.censusPlanFlagCell,
                                                                            )}
                                                                        >
                                                                            {" "}
                                                                        </td>
                                                                    )}
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                            styles.censusPlanFlagCell,
                                                                        )}
                                                                    >
                                                                        {" "}
                                                                    </td>
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                            styles.censusPlanFlagCell,
                                                                        )}
                                                                    >
                                                                        <label
                                                                            className={css(
                                                                                styles.checkLabel,
                                                                            )}
                                                                        >
                                                                            <Checkbox
                                                                                aStyles={
                                                                                    styles.check
                                                                                }
                                                                                checked={
                                                                                    !!dep.isTobacco
                                                                                }
                                                                                name={
                                                                                    inputNames.isTobacco
                                                                                }
                                                                                onChange={e =>
                                                                                    this._handleInputChange(
                                                                                        e,
                                                                                        cen,
                                                                                        dep,
                                                                                    )
                                                                                }
                                                                            />
                                                                            {/*strings.isTobacco*/}
                                                                        </label>
                                                                        {/*
                                                                    <SmallDropdown
                                                                        tabIndex={
                                                                            index * 100 +
                                                                            index2 * 100 +
                                                                            21
                                                                        }
                                                                        name={inputNames.isTobacco}
                                                                        placeholder="- Y/N -"
                                                                        options={this.state.yesNo.map(
                                                                            o => ({
                                                                                label: o.name,
                                                                                value: o.id,
                                                                            }),
                                                                        )}
                                                                        onChange={e =>
                                                                            this._setTobacco(
                                                                                e,
                                                                                cen,
                                                                                dep,
                                                                            )
                                                                        }
                                                                        value={
                                                                            dep.isTobacco
                                                                                ? "1"
                                                                                : "0"
                                                                        }
                                                                    />
                                                                    */}
                                                                    </td>
                                                                    <td
                                                                        className={css(
                                                                            styles.censusTableCell,
                                                                            styles.censusActionCell,
                                                                        )}
                                                                    >
                                                                        <CancelIcon
                                                                            className={css(
                                                                                styles.clearCensusButton,
                                                                            )}
                                                                            onClick={() =>
                                                                                this._removeDependent(
                                                                                    cen,
                                                                                    dep,
                                                                                )
                                                                            }
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                        <tr>
                                                            <td
                                                                colSpan="22"
                                                                className={css(
                                                                    styles.censusTableCell,
                                                                    styles.censusTableCellLink,
                                                                    styles.censusTableCellRight,
                                                                    styles.blueBar,
                                                                )}
                                                                onClick={() =>
                                                                    this._addDependent(cen)
                                                                }
                                                            >
                                                                Add Dependent
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                );
                                            })}
                                            <tr>
                                                <td
                                                    colSpan="22"
                                                    className={css(
                                                        styles.censusTableCell,
                                                        styles.censusTableCellLink,
                                                        styles.censusTableCellCenter,
                                                        styles.greenBar,
                                                    )}
                                                    onClick={this._addCensusMember}
                                                >
                                                    Add Employee
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Column>
                            </Row>
                        </Container>
                    </div>
                )}
                <Modal show={showCurrentPlansModal && true} header={"Current Plans"}>
                    <div className={css(styles.modal_Content)}>
                        {/* Start - Header Section with Funding Type and Carrier Controls */}
                        <div className={css(styles.modal_HeaderSection)}>
                            <div className={css(styles.modal_HeaderLeftGroup)}>
                                <div className={css(styles.modal_HeaderLabel)}>
                                    Funding Type
                                    <span className={css(styles.modal_HeaderLabelRequired)}>*</span>
                                </div>
                                <div className={css(styles.modal_HeaderControlRow)}>
                                    <button
                                        className={css(
                                            styles.modal_ToggleButton,
                                            styles.modal_PlanTypeButton,
                                            this.state.currentPlansFundingType === "0"
                                                ? styles.modal_ToggleButtonActive
                                                : null,
                                        )}
                                        type="button"
                                        tabIndex={CURRENT_PLANS_MODAL_TAB_BASE + 1}
                                        onClick={() => this._setCurrentPlansFundingType("0")}
                                    >
                                        Fully Insured
                                    </button>
                                    <button
                                        className={css(
                                            styles.modal_ToggleButton,
                                            styles.modal_PlanTypeButton,
                                            this.state.currentPlansFundingType === "1"
                                                ? styles.modal_ToggleButtonActive
                                                : null,
                                        )}
                                        type="button"
                                        tabIndex={CURRENT_PLANS_MODAL_TAB_BASE + 2}
                                        onClick={() => this._setCurrentPlansFundingType("1")}
                                    >
                                        Level Funded
                                    </button>
                                </div>
                                {!this.state.currentPlansFundingType && (
                                    <span className={css(styles.modal_HeaderHelperText)}>
                                        Select a funding type to begin mapping
                                    </span>
                                )}
                                {this.state.pendingCurrentPlansFundingType !== null && (
                                    <div className={css(styles.modal_FundingSwitchConfirm)}>
                                        <div className={css(styles.modal_FundingSwitchHeader)}>
                                            <AlertIcon
                                                className={css(styles.modal_FundingSwitchIcon)}
                                            />
                                            <div>
                                                <div
                                                    className={css(styles.modal_FundingSwitchTitle)}
                                                >
                                                    Are you sure you want to switch funding types?
                                                </div>
                                                <div
                                                    className={css(styles.modal_FundingSwitchText)}
                                                >
                                                    This will remove all current plan selections.
                                                </div>
                                                <div
                                                    className={css(
                                                        styles.modal_FundingSwitchSubText,
                                                    )}
                                                >
                                                    This action cannot be undone.
                                                </div>
                                            </div>
                                        </div>
                                        <div className={css(styles.modal_FundingSwitchDivider)} />
                                        <div className={css(styles.modal_FundingSwitchActions)}>
                                            <ActionButton
                                                aStyles={styles.modal_FundingSwitchCancel}
                                                invertColor={true}
                                                label="Cancel"
                                                type="button"
                                                onClick={this._cancelCurrentPlansFundingSwitch}
                                            />
                                            <ActionButton
                                                aStyles={styles.modal_FundingSwitchConfirmButton}
                                                label="Switch Funding Type"
                                                type="button"
                                                onClick={this._confirmCurrentPlansFundingSwitch}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className={css(styles.modal_HeaderRightGroup)}>
                                <div className={css(styles.modal_HeaderLabel)}>Carrier</div>
                                <div
                                    className={css(
                                        styles.modal_CarrierDropdownWrap,
                                        !this.state.currentPlansFundingType ||
                                            this.state.pendingCurrentPlansFundingType !== null
                                            ? styles.modal_CarrierDropdownDisabled
                                            : null,
                                    )}
                                >
                                    <SmallDropdown
                                        aStyles={styles.modal_CarrierDropdownSmall}
                                        tabIndex={CURRENT_PLANS_MODAL_TAB_BASE + 3}
                                        placeholder="All Carriers"
                                        options={(this.state.currentPlansAvailableCarriers &&
                                        this.state.currentPlansAvailableCarriers.length > 0
                                            ? this.state.currentPlansAvailableCarriers
                                            : ["All Carriers"]
                                        ).map(carrier => ({
                                            label: carrier,
                                            value: carrier,
                                        }))}
                                        value={this.state.currentPlansCarrier || "All Carriers"}
                                        onChange={selected =>
                                            this._setCurrentPlansCarrier(selected.value)
                                        }
                                    />
                                </div>
                                <span className={css(styles.modal_HeaderHelperText)}>
                                    Optional filter for available carriers
                                </span>
                            </div>
                        </div>
                        {/* End - Header Section with Funding Type and Carrier Controls */}

                        {/* Disable rest of modal if funding type not selected */}
                        <div
                            className={css(
                                this.state.currentPlansFundingType &&
                                    this.state.pendingCurrentPlansFundingType === null
                                    ? null
                                    : styles.modal_DisabledOverlay,
                            )}
                        >
                            <div className={css(styles.modal_FormSection)}>
                                <div className={css(styles.modal_MappingBox)}>
                                    <div className={css(styles.modal_GridHeader)}>
                                        <div>#</div>
                                        <div>Base Plan</div>
                                        <div>Plan Alias</div>
                                        <div className={css(styles.modal_Arrow)}>&rarr;</div>
                                        <div>Existing Plan</div>
                                        <div></div>
                                    </div>
                                    {(() => {
                                        const numRows = currentPlansRowCount;
                                        const jsxRows = [];

                                        for (let i = 0; i < numRows; i++) {
                                            const rowId = i + 1;
                                            const rowTabBase =
                                                currentPlansGridTabStart +
                                                i * CURRENT_PLANS_TAB_STRIDE_PER_ROW;
                                            const isMappedRow = !!(
                                                (this.state.currentPlanSelectionByRow[rowId] || {})
                                                    .value ||
                                                (this.state.mappedPlansByRow[rowId] || {})
                                                    .mappedPlanId
                                            );
                                            jsxRows.push(
                                                <div
                                                    key={`plan-${rowId}`}
                                                    className={css(
                                                        styles.modal_GridRow,
                                                        i === numRows - 1
                                                            ? styles.modal_LastRow
                                                            : null,
                                                    )}
                                                >
                                                    <div className={css(styles.modal_RowNum)}>
                                                        {rowId}
                                                    </div>
                                                    <div className={css(styles.modal_BasePlanCell)}>
                                                        <Checkbox
                                                            tabIndex={rowTabBase}
                                                            checked={
                                                                this.state
                                                                    .currentPlansBasePlanRow ===
                                                                    rowId && isMappedRow
                                                            }
                                                            disabled={!isMappedRow}
                                                            onChange={() =>
                                                                this._toggleBasePlanRow(rowId)
                                                            }
                                                        />
                                                        <span
                                                            className={css(
                                                                this.state
                                                                    .currentPlanSelectionByRow[
                                                                    rowId
                                                                ] &&
                                                                    this.state
                                                                        .currentPlanSelectionByRow[
                                                                        rowId
                                                                    ].value
                                                                    ? styles.modal_GreenDot
                                                                    : styles.modal_OrangeDot,
                                                            )}
                                                        />
                                                    </div>
                                                    <input
                                                        className={css(styles.modal_Input)}
                                                        tabIndex={rowTabBase + 1}
                                                        value={
                                                            typeof this.state.currentPlans[i] ===
                                                            "string"
                                                                ? this.state.currentPlans[i]
                                                                : (this.state.currentPlans[i] &&
                                                                      (this.state.currentPlans[i]
                                                                          .alias ||
                                                                          this.state.currentPlans[i]
                                                                              .name)) ||
                                                                  ""
                                                        }
                                                        placeholder={`Plan ${rowId}`}
                                                        onChange={e =>
                                                            this._handleCurrentPlanAliasChange(
                                                                rowId,
                                                                e.target.value,
                                                            )
                                                        }
                                                        onFocus={() =>
                                                            this._handleCurrentPlanAliasFocus(rowId)
                                                        }
                                                        onBlur={() =>
                                                            this._handleCurrentPlanAliasBlur(rowId)
                                                        }
                                                    />
                                                    <div className={css(styles.modal_Arrow)}>
                                                        &rarr;
                                                    </div>
                                                    <SearchInput
                                                        aStyles={styles.modal_SearchInput}
                                                        key={
                                                            "ccp-existing-plan-" +
                                                            rowId +
                                                            "-" +
                                                            ((
                                                                this.state
                                                                    .currentPlanSelectionByRow[
                                                                    rowId
                                                                ] || {}
                                                            ).value || "")
                                                        }
                                                        tabIndex={rowTabBase + 2}
                                                        search={term =>
                                                            this._searchCurrentPlans(term, rowId)
                                                        }
                                                        onItemSelected={item =>
                                                            this._handleCurrentPlanRowChange(
                                                                rowId,
                                                                item,
                                                            )
                                                        }
                                                        onTextChanged={value =>
                                                            this._handleCurrentPlanRowTextChange(
                                                                rowId,
                                                                value,
                                                            )
                                                        }
                                                        revertOnBlur={true}
                                                        placeholder="Search & select a plan..."
                                                        hideLabel={true}
                                                        type={searchInputTypes.textNoIconShort}
                                                        value={
                                                            (
                                                                this.state
                                                                    .currentPlanSelectionByRow[
                                                                    rowId
                                                                ] || {}
                                                            ).label || ""
                                                        }
                                                    />
                                                    <div className={css(styles.modal_Trash)}>
                                                        <GarbageIcon
                                                            className={css(styles.modal_TrashIcon)}
                                                            onClick={() =>
                                                                this._removeCurrentPlanRow(rowId)
                                                            }
                                                        />
                                                    </div>
                                                </div>,
                                            );
                                        }

                                        return jsxRows;
                                    })()}
                                </div>
                                <div className={css(styles.modal_AddRow)}>
                                    <div className={css(styles.modal_MappingLegend)}>
                                        <span className={css(styles.modal_LegendItem)}>
                                            <span className={css(styles.modal_MappedDot)}></span>
                                            Mapped
                                        </span>
                                        <span className={css(styles.modal_LegendItem)}>
                                            <span className={css(styles.modal_UnmappedDot)}></span>
                                            Unmapped
                                        </span>
                                    </div>
                                    <button
                                        className={css(styles.modal_AddPlanButton)}
                                        type="button"
                                        tabIndex={CURRENT_PLANS_MODAL_TAB_BASE + 900}
                                        onClick={this._addCurrentPlan}
                                    >
                                        + Add Plan
                                    </button>
                                </div>
                            </div>

                            <div className={css(styles.modal_FormSection)}>
                                <div className={css(styles.modal_SectionTitle)}>Rate Type</div>
                                <div className={css(styles.modal_ToggleRow)}>
                                    <button
                                        className={css(
                                            styles.modal_ToggleButton,
                                            isLevelFundedSelected
                                                ? styles.modal_ToggleButtonDisabled
                                                : null,
                                            currentPlansRateType === "age"
                                                ? styles.modal_ToggleButtonActive
                                                : null,
                                        )}
                                        type="button"
                                        tabIndex={CURRENT_PLANS_MODAL_TAB_BASE + 901}
                                        disabled={isLevelFundedSelected}
                                        onClick={this._setCurrentPlansRateTypeAge}
                                    >
                                        Age
                                    </button>
                                    <button
                                        className={css(
                                            styles.modal_ToggleButton,
                                            currentPlansRateType === "composite"
                                                ? styles.modal_ToggleButtonActive
                                                : null,
                                        )}
                                        type="button"
                                        tabIndex={CURRENT_PLANS_MODAL_TAB_BASE + 902}
                                        onClick={this._setCurrentPlansRateTypeComposite}
                                    >
                                        Composite
                                    </button>
                                </div>
                                {currentPlansRateType === "age" && (
                                    <div className={css(styles.modal_AgeWarning)}>
                                        Age Rated: Age-banded rates will be calculated automatically
                                        based on the census data after plan mapping is complete.
                                    </div>
                                )}
                            </div>

                            {currentPlansRateType === "composite" && (
                                <div className={css(styles.modal_FormSection)}>
                                    <div className={css(styles.modal_SectionTitle)}>
                                        Composite Rates
                                    </div>
                                    <div className={css(styles.modal_Box)}>
                                        <div className={css(styles.modal_RateHeader)}>
                                            <div>Plan Name</div>
                                            <div>EE</div>
                                            <div>ES</div>
                                            <div>EC</div>
                                            <div>EF</div>
                                        </div>
                                        {Object.keys(this.state.currentPlanSelectionByRow || {})
                                            .length > 0 ? (
                                            Object.keys(this.state.currentPlanSelectionByRow)
                                                .filter(
                                                    rowId =>
                                                        this.state.currentPlanSelectionByRow[
                                                            rowId
                                                        ] &&
                                                        this.state.currentPlanSelectionByRow[rowId]
                                                            .value,
                                                )
                                                .map((rowId, mappedRowIndex) => (
                                                    <div
                                                        key={`rate-${rowId}`}
                                                        className={css(styles.modal_RateRow)}
                                                    >
                                                        <div className={css(styles.modal_RateName)}>
                                                            {(this.state.mappedPlansByRow[rowId] &&
                                                                (this.state.mappedPlansByRow[rowId]
                                                                    .mappedPlanName ||
                                                                    this.state.mappedPlansByRow[
                                                                        rowId
                                                                    ].alias)) ||
                                                                `Plan ${rowId}`}
                                                        </div>
                                                        {["EE", "ES", "EC", "EF"].map(
                                                            (rateKey, rateIndex) => (
                                                                <div
                                                                    key={`${rowId}-${rateKey}`}
                                                                    className={css(
                                                                        styles.modal_Currency,
                                                                    )}
                                                                >
                                                                    <div
                                                                        className={css(
                                                                            styles.modal_CurrencySign,
                                                                        )}
                                                                    >
                                                                        $
                                                                    </div>
                                                                    <input
                                                                        className={css(
                                                                            styles.modal_CurrencyValue,
                                                                        )}
                                                                        tabIndex={
                                                                            currentPlansRateTabStart +
                                                                            mappedRowIndex * 4 +
                                                                            rateIndex
                                                                        }
                                                                        type="text"
                                                                        value={
                                                                            ((
                                                                                this.state
                                                                                    .mappedPlansByRow[
                                                                                    rowId
                                                                                ] || {}
                                                                            ).rates ||
                                                                                DEFAULT_COMPOSITE_RATES)[
                                                                                rateKey
                                                                            ]
                                                                        }
                                                                        onMouseDown={
                                                                            this
                                                                                ._handleCompositeRateInputMouseDown
                                                                        }
                                                                        onFocus={
                                                                            this
                                                                                ._handleCompositeRateInputFocus
                                                                        }
                                                                        onChange={e =>
                                                                            this._handleCompositeRateChange(
                                                                                rowId,
                                                                                rateKey,
                                                                                e.target.value,
                                                                            )
                                                                        }
                                                                        onBlur={() =>
                                                                            this._commitCompositeRate(
                                                                                rowId,
                                                                                rateKey,
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            ),
                                                        )}
                                                    </div>
                                                ))
                                        ) : (
                                            <div className={css(styles.modal_RateRow)}>
                                                <div className={css(styles.modal_RateName)}>
                                                    No mapped plans
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                        {/* End of modal_DisabledOverlay */}
                    </div>
                    <div className={css(styles.modal_ButtonContainer)}>
                        <ActionButton
                            aStyles={styles.modal_Button}
                            label="Cancel"
                            invertColor={true}
                            type="button"
                            tabIndex={CURRENT_PLANS_MODAL_TAB_BASE + 990}
                            onClick={this._closeCurrentPlansModal}
                        />
                        <ActionButton
                            aStyles={styles.modal_ButtonPrimary}
                            disabled={
                                !this.state.currentPlansFundingType ||
                                this.state.pendingCurrentPlansFundingType !== null
                            }
                            label="Save"
                            type="button"
                            tabIndex={CURRENT_PLANS_MODAL_TAB_BASE + 991}
                            onClick={this._saveCurrentPlansModal}
                        />
                    </div>
                </Modal>
                <Modal show={showModal} header="Level Funded Product Settings">
                    <div className={css(styles.modalContent)}>
                        <div>
                            <p>
                                You chose to include a Level Funded product that requires{" "}
                                {stopLossAmount > 0 ? "ISL and" : ""} PEPM. Please confirm the{" "}
                                {stopLossAmount > 0 ? "amounts" : "amount"} below.
                            </p>
                            <table className={css(styles.censusTable)}>
                                <tbody>
                                    {stopLossAmount > 0 ? (
                                        <tr>
                                            <td className={css(styles.censusTableCell)} style={{ width: "70%" }}>
                                                Stop Loss ($):
                                            </td>
                                            <td className={css(styles.censusTableCell)} style={{ width: "30%" }}>
                                                <SmallDropdown
                                                    placeholder="- Stop Loss -"
                                                    options={stopLossAmounts.map(o => ({
                                                        label: o.toString(),
                                                        value: o.toString(),
                                                    }))}
                                                    onChange={this._handleISLChanged}
                                                    value={
                                                        stopLossAmount
                                                            ? stopLossAmount.toString()
                                                            : ""
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    ) : null}
                                    <tr>
                                        <td className={css(styles.censusTableCell)} style={{ width: "70%" }}>
                                            PEPM ($):
                                        </td>
                                        <td className={css(styles.censusTableCell)} style={{ width: "30%" }}>
                                            <TextInput
                                                placeholder="- PEPM -"
                                                onChange={this._handlePEPMChanged}
                                                data-type="number"
                                                hideLabel={true}
                                                size="small"
                                                value={defaultPEPM ? defaultPEPM.toString() : ""}
                                            />
                                        </td>
                                    </tr>
                                    {defaultNetwork !== "" ? (
                                        <tr>
                                            <td className={css(styles.censusTableCell)} style={{ width: "70%" }}>
                                                Angle Network:
                                            </td>
                                            <td className={css(styles.censusTableCell)} style={{ width: "30%" }}>
                                                <SmallDropdown
                                                    placeholder="- Network -"
                                                    options={networks.map(o => ({
                                                        label: o.toString(),
                                                        value: o.toString(),
                                                    }))}
                                                    onChange={this._handleNetworkChanged}
                                                    value={defaultNetwork}
                                                />
                                            </td>
                                        </tr>
                                    ) : null}
                                </tbody>
                            </table>
                            {showErisa ? (
                                <div>
                                    <p>
                                        Only Groups that are subject to ERISA can enroll in Blue Balance Funded products.
                                    </p>
                                    <table className={css(styles.censusTable)}>
                                        <tbody>
                                            <tr>
                                                <td className={css(styles.censusTableCell)} style={{ width: "80%" }}>
                                                    Subject to ERISA?
                                                </td>
                                                <td className={css(styles.censusTableCell)} style={{ width: "20%" }}>
                                                    <SmallDropdown
                                                        placeholder="- Y/N -"
                                                        options={this.state.yesNo.map(
                                                            o => ({
                                                                label: o.name,
                                                                value: o.id,
                                                            }),
                                                        )}
                                                        onChange={this._handleErisaChanged}
                                                        value={erisa ? "1" : "0"}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className={css(styles.modalButtonContainer)}>
                        <ActionButton
                            aStyles={styles.modalButton}
                            label="Continue"
                            invertColor={true}
                            type="button"
                            onClick={this._continueSubmit}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}
